export default {
  ActionConfirm: "Әрекетті растаңыз",
  ActivatePromocode: "Промокодты белсендіру",
  AddFile: "Файлды қосу",
  AddToFavorites: "Таңдаулыға қосу",
  "Andar Bahar": "Андар Бахар",
  ApplyFilter: "Сүзгіні қолдану",
  AppsPage: {
    blocks: {
      descriptionOne: "Өзекті айналарды іздеудің қажеті жоқ",
      descriptionThree: "Барлық науқандар, турнирлер және ұтыс ойындары туралы дербес хабарламалар",
      descriptionTwo: "Қосымша пайдаланушылары үшін бірегей науқандар мен ұсыныстар",
      titleOne: "ОЛИМП әрқашан қолжетімді",
      titleThree: "Барлық оқиғалар мен ұсыныстардан хабардар болыңыз",
      titleTwo: "Эксклюзивті науқандар мен турнирлер"
    },
    dontWorry: "Уайымдамаңыз, бұл қауіпсіз",
    howToInstall: "Қалай орнатуға болады",
    installAndroid: "Android үшін жүктеу",
    installIos: "iOS-қа орнату",
    installIsSafe: "Орнату қауіпсіз",
    qrText: "Қосымшаны жүктеу үшін камераны QR кодқа бағыттаңыз",
    safeDescription: "Google-дың құмар ойындарға қатысты саясатына байланысты қосымшаны Play Market-те шығара алмаймыз. Орнату үшін нұсқаулықты орындаңыз",
    seo: {
      all: {
        block_one: {
          description: "{platform} – ойын-сауықтың кең ауқымы бар виртуалды ставкалар мен құмар ойындарға арналған заманауи платформа. Біз пайдаланушылардың жайлылығына ерекше көңіл бөлеміз, сондықтан біздің онлайн платформамызға кез келген құрылғыдан, компьютерден де, смартфоннан да кіруге болады. Олимп казино мобильді қосымшасы танымал операциялық жүйелер — Android және iOS-та жұмыс істейтін барлық заманауи телефондарға бейімделген. Құмар ойын әуесқойлары өздеріне ыңғайлы уақытта кез келген жерде интернет-платформаның барлық мүмкіндіктерін пайдалана алады.",
          title: "{platform} мобильді қосымшасы"
        },
        block_three: {
          description: "Қосымшаны жүктеп алған және қосымшада тіркелген кез келген ойыншы сайттың барлық мүмкіндіктері мен құралдардың толық жиынтығына ие. Мобильді қосымшада қандай функциялар қолжетімді? Жеке кабинет арқылы сіз:",
          list: {
            five: "Ойын шотындағы қаржылық транзакциялардың тарихын зерттеу - қаражат шешу тапсырыстары, төлемдер және ставкалар.",
            four: "Бонустарды пайдалану - welcome-пакет және басқа сыйлықтар.",
            one: "Профильді икемдеу - телефон нөмірін немесе электрондық пошта мекенжайын қосу, өзіңіз туралы ақпаратты толтыру және оны өзгерту.",
            three: "Хабарламалардағы казиноның ақпараттық таратылымдарын бақылау.",
            two: "Теңгерімді тексеру, оны кез келген ыңғайлы тәсілдермен толтыру, ұтыс сомаларын шешу және лезде кэшбэк алу."
          },
          text: "Олимп казиносында тіркелуден өткен соң бірден онлайн ойнауға және ставка жасауға болады. Минималды сомаға толтырым жасап, ұнайтын ойын-сауықты таңдау қажет — біздің қосымшада ойын автоматтары, лотереялар, жылдам, спорттық және классикалық ойындар, live-казино, спортқа ставкалар және әртүрлі турнирлер бар. Olymp Casino қосымшасындағы онлайн сессия кезінде сұрақтар пайда болса, техникалық қолдау көмекке келеді. Ол үшін чатты ашып, арнайы нысанда хабарлама қалдыру жеткілікті.",
          title: "Функционалды"
        },
        block_two: {
          description: "Қосымшалар дүкендері - Google Play Market, AppGallery және басқа маркеттер - құмар ойындарға қатысты әртүрлі саясаттарға ұстанады және әрқашан каталогтарында әрқашан қажетті бағдарламалық софтты орналастырмайды. Біз сіз үшін іздеу процесін жеңілдеттік және барлық операциялық жүйелерге арналған Олимп казино мобильді қосымшасын қоғамдық қолданысқа орналастырдық - оны тікелей біздің ресми сайтымыздан оңай жүктеуге болады. Келесі әрекет алгоритмдерінің бірін таңдауға болады:",
          list: {
            one: "Компьютерді пайдалану. Ол үшін кез келген браузер арқылы ресми {platform} порталын іске қосыңыз немесе іздеу жүйесі арқылы жұмыс айнасын ашыңыз. Порталда сіз «iOS үшін орнату» және «Android үшін жүктеу» батырмалары бар парақшаны табасыз. Тиісті нұсқаға басып, телефон камерасын пайдалану арқылы QR кодын сканерлеңіз. Экранда сілтеме пайда болады - оған басыңыз. Егер сіз iPhone пайдалансаңыз, қосымшаны жүктеп алуға болатын App Store дүкеніндегі қосымшаға қайта бағытталасыз. Егер сізде Android болса, қосымшаны орнатуға рұқсат беріп, орнатудың аяқталуын күту қажет.",
            two: "Мобильді құрылғыларды пайдалану. {platformSite} сайтына өтіңіз - Олимп сайтының мобильді нұсқасы ашылады. Қосымшаны тегін жүктеу үшін алдымен смартфонның операциялық жүйесіне байланысты екі жүктеп алу батырмаларының ішінен қажеттісін таңдаңыз. Телефоныңыздың «Икемдеулерін»тексеруді және белгісіз файлдарды орнатуға рұқсат беруді ұмытпаңыз — бұл қауіпсіз. Қосымша бірнеше минут ішінде жүктеледі"
          },
          text: "«Кіру» батырмасын басып, кіруді жалғастырыңыз. Егер сізде {platform}-да аккаунт жоқ болса, аккаунт ашудың уақыты келді. Тиісті өрістерге телефон нөміріңізді немесе электрондық поштаңызды енгізіңіз, жақсы парольді ойлап табыңыз және әрекетті растаңыз.",
          title: "Қосымшаны қай жерде жүктеп алуға болады"
        }
      },
      android: {
        block_four: {
          description: "{platform} мобильді қосымшасы ағылшын, қазақ, өзбек, қырғыз және орыс тілдерінде жұмыс істейді — оны кез келген уақытта өзгертуге болады. Қосымша телефон арқылы максималды ыңғайлы пайдалануға бейімделген — барлық интерфейс элементтері ұялы экрандардың өлшемін ескере отырып, қосымшаға көшірілді. Жүйеге кірген әрбір смартфон иесі сайттың компьютерлік нұсқасының барлық функцияларына қол жеткізе алады:",
          list: {
            five: "Жеке хабарламалар.",
            four: "Төлемдер, ставкалар және шоттан шығаруға тапсырыстар тарихы.",
            one: "Профильді икемдеу.",
            three: "Промокодтар мен сыйлықтар - фриспиндер, фрибеттер және депозитке бонустар.",
            two: "Ойын шотымен операциялар - толтыру, қаражат шығару және лезде кешбэк."
          },
          text: "Ең бастысы — телефон немесе планшет арқылы сіз өзіңізді қызықтыратын кез келген ойындарды сынап көре аласыз, спортқа ставка жасау кезінде сәттілікті байқап, науқандар мен турнирлерге қатыса аласыз. Олимп казиносы әрқашан қолжетімді болады және жеке хабарландырулардың арқасында сіз эксклюзивті ұсыныстарды жіберіп алмайсыз.",
          title: "Функционалды"
        },
        block_one: {
          description: "{platform}-да орналасқан жеріне қарамастан рахатпен демалуды қалайтындардың барлығына арналған құмар ойын-сауықтарының бай топтамасы бар. Спортқа ставкалар мен лотереялар, жылдам және бет ойындары, live-казино мен слоттар — ойын софты тікелей телефоннан қолжетімді! Андроид операциялық жүйесіне негізделген смартфондардың иелері бәріне қол жеткізе алады — арнайы сіздер үшін Андроид-қа арнайы Олимп мобильді қосымшасын әзірледік. Шотты телефон немесе планшет арқылы толтырыңыз, сүйікті ойын автоматтары мен слоттарды онлайн іске қосыңыз және процестен ләззат алыңыз.",
          title: "Android үшін Олимп Казино қосымшасы"
        },
        block_three: {
          description: "Android-қа арналған Олимп қосымшасын ресми сайттан тегін жүктеп алғыңыз келеді ме? Мобильді құрылғыны APK файлдарын орнатуға дайындау қажет. Алдымен, қажетті рұқсаттарды қосыңыз:",
          list: {
            four: "Экранда «Осы дереккөзден орнатуға рұқсат беру» сауалы пайда болғанда, жүктелуді бастау үшін батырманы басыңыз.",
            one: "Смартфондағы «Икемдеулер» бөліміне өтіп, «Қосымшалар» бөлімін табыңыз.",
            three: "Белгісіз қосымшаларды орнатуға рұқсат беріңіз.",
            two: "«Рұқсаттар» мәзірін ашыңыз."
          },
          text: "Андроид-қа арналған Олимп қосымшасын QR кодын пайдаланып порталдың компьютерлік нұсқасы арқылы жүктеуге болады. Код парақшада пайда болады – смартфон камерасын кодқа бағыттап, жүктеу сілтемесін күту жеткілікті. Olymp Casino мобильді нұсқасымен орнату процесі бірнеше қарапайым қадамды алады. Косымшаны смартфон арқылы жүктеу үшін, браузерде порталдың мобильді нұсқасын ашыңыз. Онда сіз «Қосымшаны жүктеу» батырмасын көресіз. Батырмаға басыңыз — және «Жүктеу» жазуын көресіз. Орнату сілтемелеріне қорықпай басыңыз — бұл қауіпсіз, файл сенімді дерек көзден жүктеледі. Дайын! Мобильді қосымшаның барлық артықшылықтарынан ләззат алуға болады. Енді сіз жұмыс істейтін айналарды іздеу немесе VPN орнату қажеттілігінен босатылдыңыз — Olymp Casino мобильді қосымшасы Ғаламторға қол жеткізу мүмкіндігіңіз болғанша жұмыс істейді. Бұл қосымшаны соңғы нұсқаға дейін жаңарту қажет болса, барлығы дұрыс жұмыс істейтеу үшін мұны жасаңыз.",
          title: "Орнату бойынша нұсқаулық"
        },
        block_two: {
          description: "Android-қа арналған {platform} мобильді қосымшасы — үздік құмар ойындар мен спорттық ставкалар әлеміне арналған өткізгіш. Қосымшаны қайдан жүктеп алуға болады? Android жүйесіне арналған мобильді маркеттерде — мысалы, Google Play Market, AppGallery немесе кез келген басқа ұқсас қосымшалар дүкенінде құмар ойындарға қатысты арнайы саясаттар бар. Онда сіз тек бөгде әзірлеушілердің жобаларын таба аласыз. Олардың Olymp Casino ресми сайтына еш қатысы жоқ. Біздің қосымшамыздың түпнұсқасын табу olymp.casino негізгі сайтын компьютер немесе мобильді құрылғы арқылы ашу қажет.",
          title: "Қолданбаны қай жерден жүктеуге болады"
        }
      },
      ios: {
        block_one: {
          description: "IPhone және iPad иелері арасында {platform} құмар ойындарының жанкүйерлері көп. iOS операциялық жүйесіне негізделген құрылғыларға арналған мобильді қосымшамыз пайдаланушылар үшін кең мүмкіндіктер ашады және іс-әрекеттің толық еркіндігін қамтамасыз етеді. Кез келген уақытта қалтаңызда ғаламтор-казиносының толық функционалы бар ойын-сауықтың үлкен каталогы болады. Шотты толтырыңыз, профиль деректерін басқарыңыз, кез келген көлемдегі жүлделерді қолма-қол ақша түрінде алыңыз, онлайн режимде ойнаңыз және күн сайын жаңа ойындарды ойнап көріңіз. IOS-қа арналған Олимп казино мобильді бағдарламасы сізге қалағаныңызша көңіл көтеруге және пайда табуға көмектеседі! Мұны істеу үшін телефонды немесе планшетті дұрыс «жабдықтап», ойын-сауыққа көшу қажет.",
          title: "iPhone үшін Олимп Казино iOS қосымшасы"
        },
        block_three: {
          description: "IOS платформасы негізіндегі құрылғыларға арналған Олимп казино қосымшасы ойын-сауық ойындарының барлық жинағына толық қол жеткізуге мүмкіндік береді - көптеген слоттар, үстел үсті, спорттық және краш ойындар, үстелдер, лотереялар, науқандар, турнирлер. Мобильді қосымшадағы жеке кабинет арқылы сіз кез келген қажетті әрекеттерді орындай аласыз:",
          list: {
            five: "Операциялар тарихын қарау - қаражат шығаруға барлық тапсырыстар, транзакциялар және ставкалар.",
            four: "Казинодан келген хабарламаларды оқу.",
            one: "Профильдегі жеке ақпаратты өзгерту және верификацияны өту.",
            three: "Сыйлықтарды алу, белсендіру және сыйлықтарға ставка жасау, соның ішінде жаңадан тіркелген ойыншылар үшін welcome-бонус.",
            two: "Шотты толтыру, ұтысты шешу және лезде кешбэк алу."
          },
          text: "Мобильді қосымша пайдаланушылары үшін көптеген бірегей ұсыныстар бар: барлық оқиғалардан хабардар болу және тиімді науқандар, ағымдағы ұтыс ойындары және эксклюзивті турнирлер туралы уақытылы білу үшін, хабарландыруларды қосуды ұмытпаңыз. Депозитті толтыру, ставкалар жасау, ойын автоматтарын «тесттілеудің» және сәттілікке жетудің уақыты келді. Olymp казино қосымшасындағы әрбір виртуалды сеанс сізге тек жағымды әсер қалдыру үшін барлығын жасадық.",
          title: "Функционал және мүмкіндіктер"
        },
        block_two: {
          description: "Біз пайдаланушыларды ойынға қажетті құралдармен қалай тиімді және ыңғайлы түрде қамтамасыз ету қажеттігін білеміз. {platform} мобильді қосымшасы Apple дүкенінде қолжетімді — ол тегін. iOS-қа арналған ресми Олимп қосымшасын жүктеу үшін App Store дүкенінен жүктеу сілтемесін алу қажет. Мұны істеудің екі жолы бар – ыңғайлысын таңдауға болады:",
          list: {
            one: "Компьютерде Олимп казиносының ресми сайтын іске қосыңыз және мобильді қосымшаға сілтеме бар парақшаға өтіңіз. Сіз QR кодын көресіз - оған құрылғыңыздың камерасын бағыттап, жүктеу сілтемесін басыңыз.",
            two: "{platformSite} порталына тікелей iOS платформасындағы құрылғы арқылы өтіңіз — мобильді нұсқа ашылады. Олимп қосымшасын iPhone немесе iPad-қа осылайша жүктеу үшін «iOS үшін орнату» батырмасын басыңыз. Сіз App Store дүкеніне бағытталып, қосымшаны орнатуды бастай аласыз."
          },
          text: "Жүктелу аяқталған соң, жүйеде аккаунт тіркеуге болады немесе жеке кабинет болса, жүйеге кіріп, ең қызықты бөлік — {platform} ойын-сауықтарына өтуге болады!",
          title: "Қосымшаны орнату оңай"
        }
      }
    },
    seoText: "Айфон телефондарына арналған парақшасында арнайы SEO мәтіні қажет болмауы мүмкін, бірақ қосымшаға шолу жазуға және «олимпбет қолданбасына шолу» санатының семантикасын оңтайландыруға тырысып көруге болады. Екеуінде де жиілік жоқ.",
    seoTitle: "SEO мәтіні",
    slider: {
      textEight: "Сайттағы «Қосымшаны жүктеу» батырмасын басыңыз",
      textFive: "«Орнату» батырмасын басыңыз",
      textFour: "Жүктелген қосымша файлына басыңыз",
      textOne: "Жүктеуді бастау үшін «Жүктеу» батырмасын басыңыз",
      textSeven: "Телефон камерасын QR кодына бағыттап, сайтқа өтіңіз",
      textSix: "Қосымшаны жұмыс үстелінен іске қосыңыз және ойнаңыз",
      textThree: "Белгісіз дереккөздерден қосымшаларды орнатуға рұқсат беріңіз",
      textTwo: "«Белгісіз қосымшаларды орнату» бөліміне өтіңіз"
    },
    slides: {
      allowInstall: "Белгісіз дереккөздерден орнатуға рұқсат беру",
      cancel: "Жою",
      download: "Жүктеу",
      downloadApp: "Қосымшаны жүктеу",
      downloadIsDone: "Жүктеу аяқталды",
      installUnknownApp: "Белгісіз қосымшаларды орнату",
      isntall: "Орнату",
      moveToSite: "Сайтқа өту",
      myFiles: "Менің файлдарым",
      safeDescription: "Play Market-тен емес қосымшаларды орнату. Файлды тек сенімді дереккөзден жүктеңіз",
      settings: "Икемдеулер"
    },
    textForMobile: {
      androidAndIos: "Android және iOS-қа ",
      downloadOnAndroid: "Android-қа жүктеу",
      downloadOnAndroidAndIos: "Android және iOS-қа жүктеу",
      downloadOnIos: "iOS-қа жүктеу",
      onAndroid: "Android-қа",
      onIos: "iOS-қа"
    },
    title: "Олимп қосымшасы"
  },
  Aviator: "Авиатор",
  Basket: "Қоржын",
  BeforeEndPromotion: "Акцияның аяқталуына дейін",
  BeforeStartPromotion: "Акцияның басталуына дейін",
  Betgames: "Betgames",
  Bets: "Ставкалар",
  BonusBalanceOff: "Сіз казиноның негізгі бонустық теңгеріміне ауыстыңыз. Шотты толтырыңыз және сүйікті ойындарыңызды ойнаңыз.",
  BonusBalanceOn: "Сіз бонустық теңгерімге ауыстыңыз.",
  BonusesAndPromotions: "Бонустар мен акциялар",
  BonusesAndPromotionsSection: "Бонустар мен акциялар бөлімі",
  Categories: "Санаттар",
  Chat: "Чат",
  CloseMatchTracker: "Матч-трекерді жабу",
  CoefficientChanged: "Коэффициент өзгерді",
  ContactSupport: "Қолдау қызметіне хабарласыңыз",
  "Cricket X": "Крикет X",
  DeleteConfirm: "Жоюды растау",
  DeleteConfirmText: "Сіз бұрын жүктелген файлдарды шынымен жойғыңыз келе ме?",
  DeleteFiles: "Файлды жою",
  DenyReason: "Белгілі бір себеппен бас тартылды",
  DocumentAlreadyAttached: "Бұл файл бекітілген",
  DocumentDoesntMeetRequirements: "Құжат талаптарға сәйкес келмейді",
  DocumentResolutionTooBig: "Фотосуреттің шешімі тым үлкен. Рұқсат етілген ең жоғары өлшем - {value} Мп",
  DocumentsFilesLimits: "(файлдардың ең көп саны - {fields}, файлдардың ең көп мөлшері - {size} Мб)",
  DocumentsUploadError: "Файлдарды жүктеу кезінде қателік орын алды - {files}. Қалған файлдар тексеруге жіберілді. Бұл файлдарды қайта жүктеп көруге болады",
  DownloadOn: "Жүктеп алу",
  EuroLanding: {
    activate: "«Бонустар» бөлімінде <br /><span>белсендіріңіз</span>",
    bonusText: "<span>Тіркелу үшін</span><span>фрибет!</span><b>{freebet}</b>",
    register: "Olymp Casino сайтында <br /><span>тіркеліңіз</span>"
  },
  Event: "Оқиға",
  Exclusive: "Exclusive",
  Expires: "Аяқталады",
  ForbidenBonus: "Бүгінгі күн үшін сыйлықтар алынған",
  Found: "Табылды",
  FruityWheel: {
    btn: "Айналдыр",
    title: "Айналдыр және өз welcome бонусыңды біл"
  },
  GatesOfOlympus: {
    completeSignIn: "Тіркелуді қазір аяқтаңыз және бонус алыңыз",
    getBonus: "Бонусты алу",
    spin: "Айналдыр",
    titleFirstLine: "Дөңгелекті айналдыр",
    titleSecondLine: "бонустар ал",
    twist: "Айналдыру",
    youWin: "Сіз ұттыңыз",
    yourBonus: "Сіздің бонусыңыз"
  },
  GetYourPrizes: "Жүлделерді ал",
  GoldenTimesKz: {
    bonusText: "Құттықтаймыз! Сіздің ұтыстарыңыз",
    headTitle: "Бонусыңды ал да,<br /> джекпотқа ие бол!",
    labelText: "Телефон нөміріңізді енгізіңіз"
  },
  InformationAllPromotions: "Барлық акциялар бойынша ақпарат",
  InitialCoefficient: "Бастапқы коэф.:",
  JetX: "JetX",
  LongTermRates: "Ұзақ мерзімді ставкалар",
  MainSite: "Негізгі сайт",
  MatchTracker: "Матч-трекер",
  MaximizeMatchTracker: "Матч-трекерді ұлғайту",
  MinimizeMatchTracker: "Матч-трекерді азайту",
  Mobile: "Мобильді",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "Мәзір тармағын таңда /app",
    getLink: "немесе Telegram ботында сілтемені ал",
    getLinkButton: "Сілтеме алу",
    groups: {
      four: "Барлық оқиғалар мен ұсыныстардан <br/> хабардар болыңыз",
      one: "<span>100 FS депозитсіз</span> қосымшаны орнату үшін",
      three: "Эксклюзивті <br/>науқандар және турнирлер",
      two: "Іздеу қажет емес <br/>өзекті айналар\n\n"
    },
    start: "/start",
    startText: "/start басып, Telegram ботты іске қос",
    successLink: "Сілтеме сәтті жіберілді",
    text: "Olymp мобильді қосымшасын жүктеп алып, кез келген уақытта ойнауға дайын бол",
    title: "<span>100 FS <br/>депозитсіз </span> OLYMP орнату үшін"
  },
  MobileApplications: "Мобильді қосымшалар",
  MyDocuments: "Менің құжаттарым",
  NewYearRules: {
    "1": "Науқан өткізілу мерзімі: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +5",
    "10": "Aviator фрибеттері",
    "11": "JetX фрибеттері",
    "12": "Промо парақшасында бонусты ұтқан жағдайда, бонус «Бонустар» бөлімінде «Бонусқа өту» батырмасын басу арқылы жеке кабинетке қосылады",
    "13": "Есептелген бонустарды белсендіру 3 күн ішінде қол жетімді",
    "14": "Бонусты белсендірген соң депозитті 1 күн ішінде жасау қажет",
    "15": "Бонустық қаражатқа ақша шешу шарттарын 1 күн ішінде орындау қажет",
    "16": "Әрбір бонустың толық шарттары жеке кабинеттегі «Бонустар» парақшасында қолжетімді",
    "2": "Күн сайын промо парақшасында бонус алуға 3 әрекет беріледі",
    "3": "Әрекеттер саны 00:00 GMT +5 уақытында науқан өткізілу кезеңінде күн сайын 3-ке дейін қалпына келтіріледі.",
    "4": "Бонусты ұтып алу үшін, пайдаланушы күн сайын промо парақшасына өтіп, SPIN батырмасын басу арқылы слот машинаны іске қосу қажет.",
    "5": "SPIN батырмасын әр кез басқанда бір әрекет алынады",
    "6": "Бонус ұтысы мен бонус түрі кездейсоқ түрде анықталады:",
    "7": "Слоттардағы депозитке бонус",
    "8": "Слоттар түріндегі фриспиндер",
    "9": "Спортқа фрибеттер"
  },
  NezlobLanding: {
    forDeposit: "депозитке",
    title: "Әзілдер таусылды!"
  },
  NotCalculated: "Есептелмеген",
  NotSingleActionCurrentlyHeld: "Қазір бірде бір акция өткізіліп жатқан жоқ",
  OlimpCasino: "Олимп казино\n",
  OpenFullVersion: "Толық нұсқасын ашу",
  PaymentMethods: "Төлем тәсілдепрі",
  PlayEveryDay: "Әр күн сайын ойна",
  PromoAvailableFrom: "Акция {date} жылдан бастап қолжетімді",
  PromoAvailableFromTo: "Акция {date1} жылдан {date2} жылға дейін қолжетімді",
  PromoEnded: "Акция {date} жылы аяқталды",
  Promotions: "Акциялар",
  PromotionsWillDisplayedHere: "Мұнда акциялар көрсетіледі",
  QuestionAndAnswer: "Сұрақ – Жауап",
  RulesAcceptingBets: "«ОЛИМП» букмекерлік кеңсесінің ставкаларын қабылдау ережесі",
  RulesOfPromotion: "Науқан ережелері",
  RulesSingle: "Ережелер",
  SelectTypeSystem: "Жүйе типін таңдаңыз",
  Soon: "Жақында",
  Statistics: "Статистика",
  StayTuned: "Бізбен бірге болыңыз",
  TableContents: "Мазмұны",
  TheSearchHasNotGivenAnyResults: "Іздеу нәтиже бермеді",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "Өшіру үшін телефон мен электрондық поштаны растау қажет",
  ToMain: "Басты бетке",
  ToUp: "Жоғары",
  TypeBonusesAndPromotions: "Бонустар мен акциялар типі",
  UntilTheNextBonus: "Келесі бонусқа дейін",
  UploadDocuments: "Жүктелген файлдар",
  Version: "нұсқа",
  WeAreOnSocialMedia: "Біз әлеуметтік желідеміз",
  WeOnSocialMediaFull: "Біз әлеуметтік желідеміз",
  WorldCup: "ӘЧ-2022",
  YouDataProtected: "Жеке деректер мен қаражат қауіпсіздікте",
  YourBonus: "Сіздің бонусыңыз",
  aboutBonus: "Бонус туралы толығырақ",
  acceptWithModifiedOdds: "Өзгерген коэффициентпен қабылдау",
  acceptWithModifiedTotals: "Өзгерген тоталмен/форамен қабылдау",
  accountApprove: "Аккаунт қорғалған",
  accountNotApprove: "Аккаунт қорғалмаған",
  action: "Әрекет",
  activate: "Іске қосу",
  activateBonus: "Бонусты белсендіру",
  activateFastBets: "Жылдам ставкаларды белсендіріңіз",
  activatingPromoCode: "Промокодты белсендіру",
  active: "Белсенді",
  activeBonusErr: "Бонус белсендіру үшін, кемінде келесі сомаға толтыру жасау қалды",
  activeWager: "Белсенді вейджер",
  add: "Қосу",
  addToBasket: "Қоржынға қосу",
  addYourFavoriteGames: "Сүйікті ойындарды таңдаулыға қосыңыз",
  addingDogeCoin: "Doge монетасын қосамыз",
  additionalInfo: "Қосымша ақпарат",
  addressCryptoWallet: "Крипто әмиян мекенжайы",
  addressWallet: "Әмиян мекен-жайы",
  afterInstallApp: "You received a bonus {0} for installing the app",
  agreeTermsAndConditions: "Мен {0} келісемін және 18 жастан асқанымды растаймын",
  all: "Барлығы",
  allDepositMethods: "Барлық толтыру әдістері",
  allGames: "Барлық ойындар",
  allMessages: "Барлығы",
  allMessagesButton: "Хабарламаларға өту",
  allMessagesText: "Барлық хабарламалар",
  allPromo: "Барлық науқандар",
  allRequiredFieldsMustBeFilled: "Барлық қажетті жолдарды толтыру қажет\n",
  allTypes: "Барлық түрлер",
  allWithdrawMethods: "Ақша шешудің барлық әдістері",
  all_right: "Барлық құқықтар қорғалған.",
  alreadyHasAccount: "Тіркелген аккаунт бар",
  always: "Әрқашан",
  amountOnAccount: "Шоттағы сома",
  anUnexpectedErrorOccurred: "Күтпеген қате пайда болды!",
  antifraud: {
    five: "Көп сатылы клиентті тексеру (IP арқылы тексеру, жүйенің параметрлерін алу, проксиді тексеру); Клиенттің телефон нөмірін тексеру; Маманмен ойыншылардың мінез-құлқы анализі; Алаяқтыққа қарсы жүйеде төлем деректерін, төлем тарихы мен пайдаланушының қара тізімін терең тексеруге арналған 100-ден астам сүзгі бар; Клиент ақшаны шешу сатысында біздің бақылау қызметімен түпкілікті тексеруден өтеді.",
    four: "Негізгі сипаттамалар",
    one: "Алаяқтықтан қорғау",
    three: "Онлайн төлем қызметтерінің жетекші провайдерлерімен ынтымақтастықта біз онлайн-бизнесті сенімді жүргізу және қолданушыларымыздың жеке ақпараттарының, сондай-ақ барлық төлемдер деректерінің қауіпсіздігін қамтамасыз ету үшін барымызды саламыз. Төлем операцияларының дерекқорларын басқарудағы он жылдық тәжірибемізді Avento AntiFraud Tool кредиттік карталардағы алаяқтыққа қарсы шынымен күшті және ыңғайлы құрал етеді.",
    two: "Avento AntiFraud Tool - алаяқтық онлайн-құмар транзакцияларының алдын алуға арналған алаяқтыққа қарсы күшті құрал. Бұл біздің ойын мекемелеріміздегі кредиттік карталарындағы алаяқтықтың санын едәуір азайтуға мүмкіндік береді."
  },
  app: "Қосымша",
  appOlymp: "Олимп қосымшасы",
  apply: "Қолдану",
  approve: "Растаймын",
  approvePhoneBySms: "Нөмірді SMS арқылы растау",
  approvePhoneByTelegram: "Нөмірді Telegram арқылы растау",
  approved: "Расталды",
  approvedSecond: "Расталды",
  approvingWithdraw: "Ақша шешуді растау",
  april: "сәуір",
  areYouSureDeposit: "Шотты толтырғаныңызға сенімдісіз бе?",
  areYouSureToDeclineBonus: "Бонустан бас тартқыңыз келетініне сенімдісіз бе?",
  areYouSureYouWantToSell: "Сіз ставканы сатқыңыз келетініне сенімдісіз бе",
  attach: "Құжаттарды бекіту\n",
  attachDocumentsToVerifyAccount: "Верификацияны аяқтау және қаражатты алу үшін құжаттарды тіркеуіңізді өтінеміз.\n",
  attempt: "Әрекеттер жоқ | 1 әрекет | {count} әрекет",
  august: "тамыз",
  authApproveText: "Робот емес екеніңізді тексеру үшін «Растау» батырмасын басыңыз",
  authFromSocial: "Әлеуметтік желілер арқылы кіру",
  authorization: "Авторизация",
  authorizationRequired: "Ақылы ойын авторизацияны қажет етеді!",
  availabilityWallet: "Крипто әмиян болу қажет {wallet}",
  available: "Қолжетімді",
  availableBonuses: "Қолжетімді бонустар",
  availableOnlyGameForMoney: "Тек ақшаға ойын қолжетімді",
  back: "Артқа",
  backToHome: "Басты парақшаға оралу",
  backToLogin: "Авторизацияға оралу",
  backToOneStep: "Бірінші қадамға оралу",
  balance: "Теңгерім",
  balanceAfterTopUp: "Толтырудан кейінгі теңгерім: {value}",
  balanceAfterWithdraw: "Қаражат шығарылғаннан кейінгі теңгерім: {value}",
  balanceBK: "БК теңгерімі",
  balanceBKRefreshSuccessfully: "БК теңгерімі сәтті жаңартылды",
  balanceCasino: "Казино теңгерімі",
  balanceCasinoRefreshSuccessfully: "Казино теңгерімі сәтті жаңартылды",
  balanceSwitchByWithoutBalance: "Бонустық теңгерімге ауысу бонустық ойындарды ойнау кезінде, егер нақты теңгерімде  қаражат болмаған жағдайда ғана автоматты түрде жүзеге асырылады",
  balances: "Теңгерімдер",
  bankCard: "Банк картасы",
  basketBets: "Қоржын",
  behind: "сомаға",
  bet: "Ставка",
  betHistory: "Ставкалар",
  betID: "Ставка ID",
  betSoldFor: "Ставка {count} сомаға сатылды",
  betsAreSuspended: "Ставкаларды қабылдау тоқтатылды",
  betsNotAccessForBonusBalance: "Бонустық теңгерімнен спортқа бәс тігу мүмкін емес!",
  bettingHistory: {
    bet: "Ставка",
    coefficient: "Коэффицент",
    dataOfBet: "Бұл ставкалар",
    findOutTheScore: "Ұпай санын білу",
    numberAndDateOfBet: "Ставканың нөмірі мен күні",
    payout: "Төлем",
    status: "Мәртебе"
  },
  bidAddedToCart: "Ставка қоржынға қосылды",
  bidDeletedToCart: "Ставка қоржыннан жойылды",
  bonus: "Бонус",
  bonusActivated: "Бонус қосылды",
  bonusActivation: "Бонус белсендірілуі",
  bonusBalance: "Бонус. теңгерім\n",
  bonusBalanceOnly: "Бонустық теңгерімнен ойнау үшін бонус ойынын іске қосыңыз",
  bonusCondition: "Бонус шарттары\n",
  bonusNotActivated: "Бонус қосылмаған",
  bonusOnFirstDeposit: "Бірінші депозит үшін 100%<br/> бонус",
  bonusQuestion: "Сәлемхат бонусыңызды әлі алған жоқсыз ба?",
  bonusSport: {
    block1: {
      li1: "olymp.casino сайтында тіркеліңіз.",
      li2: "Бонусты белсендіру үшін Жеке кабинеттегі «Бонустар» бөліміне өтіп, ұсынысты белсендіріңіз.",
      li3: "Бір төлеммен 500 KZT / 12 000 UZS бастап толтырым жасаңыз.",
      li4: "Толтырудан кейін бонус автоматты түрде шотқа аударылады және купоныңыздың «Спорт» бөлімінде ставка жасауға қолжетімді болады.",
      title: "Өз бонусыңызды қалай алуға болады:"
    },
    block2: {
      li1: "Пайдаланушы тек бір бонусқа құқылы.",
      li2: "Тегін ставканы тек спортқа ғана пайдалануға болады. Сіздің купоныңыз 3 кемінде және максимум 10 коэффициенті бар дара ставка болуы тиіс.",
      li3: "Ойыншы тек ұтыс бөлігін ғана өз есебіне алады.",
      text: "Мысалы: 3 коэффициентіне тегін 500 ставка. Ойыншы 3*500-500 = 1000 шотқа алады.",
      title: "Шарттар мен ережелер:"
    },
    block3: {
      li1: "Тегін ставканы айналдыру талаптары 7 күн ішінде орындалуы қажет, әйтпесе бонустың мерзімі аяқталады.",
      li10: "Olymp.casino ұсыныс шарттарын өзгертуге, ұсыныстан бас тартуға немесе жалғастыруға немесе алдын ала ескертусіз кез келген уақытта қатысудан шектеуге құқылы.",
      li11: "Olymp.casino пайдаланушыларға осы немесе кез келген басқа ұсынысқа қатысуды шектеуі немесе бас тартуы мүмкін.",
      li12: "Бір клиент, отбасы, мекен-жайы, ортақ компьютер, ортақ IP-мекен-жайы және кез-келген бірдей есептік жазба деректері, соның ішінде электрондық пошта мекен-жайы, банктік шот деректемелері, несиелік карта және төлем жүйесінің шоты туралы ақпарат үшін тек бір бонус рұқсат етіледі. Осы бонустық ұсынысты кез келген теріс пайдалану шоттың жабылуына алып келеді.",
      li13: "Olymp.casino кез келген уақытта осы ұсынысты өзгерту немесе жою құқығын өзіне қалдырады.",
      li14: "Бонусты қабылдай отырып, клиент бонустық шарттармен, сондай-ақ Olymp.casino жалпы ережелерімен келіседі.",
      li2: "Ұтысты шығару үшін сіз ең төменгі 500 KZT депозитті жасап, х1 вейджерін орындауыңыз қажет.",
      li3: "Жойылған немесе қайтарылған жағдайда - ставка шығын ретінде есептеледі.",
      li4: "Жартылай ұтылыс жағдайында (азиялық фора және тотал) - ставка шығын ретінде есептеледі.",
      li5: "Жартылай ұтыс жағдайында (азиялық фора және тотал) - әдеттегі ставка ретінде есептеледі, ставка сомасын қоспағанда.",
      li6: "Ставканы есептегеннен кейін ақша сіздің балансыңызға түседі.",
      li7: "Тегін ставканы ішінара пайдалану мүмкін емес. (яғни, егер сізде 500 теңгеге тегін ставка болса, сіз 500 теңгеге ставка жасауыңыз қажет. Әр түрлі купондар үшін 250-250 теңге қабылданбайды).",
      li8: "Ұсынысты басқа жарнамалық немесе арнайы ұсыныстармен бірге пайдалануға болмайды.",
      li9: "Бірнеше тіркеулік жазбаны пайдалануға рұқсат етілмейді және бірнеше тіркеулік жазбалар табылған жағдайда бұл бүкіл тіркеулік жазбалардың тоқтатылуына әкеледі.",
      title: "Басқа шарттар:"
    },
    title: "Olymp.Casino-ға қосылудың ең жақсы уақыты - қазір, өйткені біз әрбір жаңа пайдаланушыға спортқа 500 KZT тегін ставка ұсынамыз."
  },
  bonusTimeLeft: "Әрекет ететін кез келді",
  bonusWager: "Бонус вейджері:",
  bonuses: "Бонустар",
  bookmakerShort: "БК",
  "break": "Үзіліс",
  bronze: "Қола",
  btn: "Касса",
  byDefault: "Әдепкі қалпы бойынша",
  byDefaultDown: "Алфавит бойынша (A-Z)",
  byDefaultUp: "Алфавит бойынша (Z-A)",
  bySport: "Спорт түрі бойынша",
  cabbage: {
    eight: "- егер ойыншы 5 күндік толық циклді аяқтаса.",
    eighteen: "Жүлде {number}",
    eleven: "Науқанға қатысу арқылы сіз осы науқанды жүргізетін онлайн-казино орнатқан шарттар мен талаптармен автоматты түрде келісесіз.",
    fifteen: "Мақсаттар мен жүлделер",
    five: "Сыйлықтар күнделікті жетістіктер және күнделікті мақсаттарды орындауымен бірге артады. Күнделікті прогресті сақтау, циклдің келесі күніне өту және үлкен сыйлықтарға ие болу үшін қатысушы күнделікті мақсатты кем дегенде бір рет орындау қажет.",
    four: "«Күнделікті сыйлықтар» науқанында күнтізбелік 5 күнге дейінгі циклдер бар, олардың әрқайсысы күнделікті мақсатты 2-ге дейін орындауға мүмкіндік береді.",
    fourteen: "Сәтсіздік жағдайында барлық ұтыстар қайтарылады.",
    list: "Шарттар мен талаптар:",
    nine: "Науқанға қатысу үшін қосымша толтырулар немесе салымдар қажет емес.",
    nineteen: "Күнделікті мақсат 1 рет орындалды",
    one: "Жоғары сапалы қырыққабатты ақшалау түрде жинайтын кез келді!",
    seven: "- егер ойыншы күнді өткізіп жіберсе немесе күнделікті мақсатты кем дегенде бір рет орындамаса;",
    seventeen: "Күнделікті мақсаттар",
    six: "Қатысушының күнделікті сыйлықтарының циклі бірінші күнге дейін 2 жағдайда жойылады:",
    sixteen: "Циклдегі күн",
    ten: "Науқанға тек нақты ақшаға ойнау арқылы қатыса аласыз. ",
    thirteen: "{company} науқанды кез келген уақытта белгісіз мерзімге тоқтату құқығын, сонымен қатар ережелерді алдын ала ескертусіз өзгертуге құқығын өзіне қалдырады.",
    three: "Қатысу үшін, Booongo провайдерінің ойындарынан кез-келгенін ойнау қажет. Жүлде қоры - қатысушыға 1160 евроға дейін. Егер қатысушы науқан бойы барлық мүмкін болатын күнделікті мақсаттарға жетсе (2 толық цикл), сома максималды жеке жүлде қоры ретінде есептеледі. Ең керемет сыйлық әр циклдің соңғы күні болады!",
    twelve: "Қатысу шарттары мен талаптары {company} қалауы бойынша кез келген уақытта өзгеруі мүмкін.",
    twenty: "Күнделікті мақсат 2 рет орындалды",
    twentyFive: "әр қатысушыға 1160 еуроға дейін!",
    twentyFour: "Жүлде қоры",
    twentyOne: "Күнделікті мақсат 3 рет орындалды",
    twentySix: "Күні мен уақыты",
    two: "Қатысу үшін, Booongo провайдерінің ойындарынан кез-келгенін ойнап, күнделікті мақсаттарға жетіңіз. Жүлде қоры - қатысушыға 1160 евроға дейін!"
  },
  cabinet: "Жеке кабинет",
  calculated: "Есептелгендер",
  calculationID: "Есептелу ID",
  canNotChangeCurrency: "Валютаны өзгерту мүмкін емес",
  canSelectSavedData: "Сақталған деректерді таңдай аласыз",
  cancel: "Бас тарту",
  cancelBonus: "Бонустан бас тарту",
  cancelBonusConfirm: "Сіз бонустан бас тартқыңыз келетініне сенімдісіз бе? Бас тартқан кезде барлық бонустық қаражат жойылады",
  cantEnterTheCode: "Кодты енгізу мүмкін емес пе?",
  carriedOut: "Орындалған",
  cashBackSum: "Жылдам Cashback сомасы",
  cashBoxApproveCode: "Растау коды",
  cashBoxApproveCodeHint: "Кассирге ақша шешуді растау үшін қажет болады",
  cashBoxDeliveryText: "Сізге ыңғайлы болу үшін, {0} сомасынан бастап қаражатты толтыру/алу кезінде сізге курьер келуі мүмкін. Курьерді шақыру үшін бізге телеграмға жазыңыз, логин {1}",
  cashbackTitle: "Cashback\n",
  cashboxAddress: "Касса мекен-жайы",
  casino: "Казино\n",
  casinoBonus: "Казино бонусы",
  casinoLogin: "{name} логині",
  categoryFromAtoZ: "А-дан Я-ға дейінгі категория",
  change: "Өзгерту",
  changeData: "Деректерді өзгерту ",
  changeEmail: "Поштаны өзгерту",
  changeMethod: "Әдісті өзгерту",
  changePassword: "Парольді өзгерту",
  changePhone: "Нөмірді өзгерту ",
  changeStatusCode: "Код мәртебесін өзгерту",
  changeTheEmail: "Электрондық поштаны өзгерту",
  changeWallet: "Әмиянды өзгерту",
  changingEmail: "Электрондық поштаны өзгерту",
  changingPhone: "Нөмірді ауыстыру",
  checkRobotText: "Робот емес екеніңізді тексеру үшін «Растаймын» батырмасына басыңыз",
  checking: "Тексерілуде",
  chooseComfortableAddress: "Кассаның ыңғайлы мекен-жайын таңдаңыз",
  chooseDepositViaCryptocurrencyMethod: "«Криптовалюта арқылы толтыру» әдісін таңдаңыз",
  chooseVariantOrContinueEnter: "Нұсқаны таңдаңыз немесе енгізуді жалғастырыңыз",
  chooseVerificationMethod: "Код арқылы ақша алуды растауды өшіру үшін әдісті таңдаңыз",
  clear: "Тазарту",
  clearFavorites: "Таңдаулыларды өшіру",
  clickCheckoutInHeaderOfSite: "Сайт тақырыбындағы «Касса» батырмасын басыңыз",
  clickHome: "«Үйге экранына» батырмасын басыңыз",
  clickOnTheOddsYouLike: "Сізге ұнайтын коэффициенттерді басу арқылы қалқымалы терезеде жылдам ставкалар жасаңыз:",
  clickSelectFrontCoin: "«Tether TRC20» сияқты монетаның қарсы жағындағы «Таңдау» батырмасын басыңыз",
  clickShare: "«Бөлісу» белгішесін басыңыз",
  clickToAttache: "Файлды бекіту үшін батырмаға басыңыз",
  clickTopMenuToBuyCrypto: "«Крипто сатып алу»  жоғарғы мәзірін нұқыңыз және «Банк картасынан» төлем әдісін таңдаңыз. Мин. сома - 10.40 USD",
  close: "Жабу",
  code: "Код\n",
  codeAlreadySendFillIt: "Біз растау кодын жібердік, оны енгізу өрісіне енгізіңіз",
  codeIsWrong: "Код дұрыс емес",
  codeSend: "Смс-код нөміріңізге жіберілді",
  codeSendToEmail: "Код электрондық поштаға жіберілді",
  codeSendToPhone: "Код нөміріңізге жіберілді",
  codeSendToTelegram: "Код Telegram-бот арқылы жіберілді",
  codeVerificationDisabled: "Код арқылы растау өшірілді",
  codeVerificationEnabled: "Код арқылы растау қосылды",
  coinSelection: "Монетаны таңдау",
  comboBoostBonus: {
    button: "Ойнау",
    content_title: "Комбобустты қалай пайдалануға болады:",
    good_luck: "Olymp.casino сізге үлкен жеңістер тілейді!",
    range_left_title: "Оқиғалар саны",
    range_right_title: "Коэффициенті",
    step_one: "Қадам 1:",
    step_one_description: "Ұтысты экспрессті жинауды қазір бастаңыз және көбейтілген коэффициентті қалай алуға болатынына назар аударыңыз.",
    step_three: "Қадам 3:",
    step_three_description: "Таңдауыңызды жасаған соң, бәс тігіңіз! Бонус сіздің қорытынды коэффициентіңізді автоматты түрде арттырады. Сіз ставкаңызды «Менің ставкаларым» бөлімінде тексере аласыз. Ол COMBOBOOST маркерімен белгіленген.",
    step_two: "Қадам 2:",
    step_two_description: "Экспрессіңізді жинауды жалғастырыңыз және бонустың өсуін бақылаңыз.",
    welcoming_range_title: "Мүмкіндіктеріңізді біліңіз.",
    welcoming_text: "Olymp.casino-да барлық жаңа қолданушылар үшін тамаша жаңалықтар бар! Бусттың жұмыс істейтініне көз жеткізу үшін, осы мүмкіндікті өзіңіз қолданып көріңіз! Біздің бонуспен қорытынды коэффициентті арттыру үшін 1,5 немесе одан жоғары коэффициентпен 2 немесе одан да көп оқиғаға экспресс ставка қойыңыз. Экспресстегі оқиғалар көбірек болса, сіздің бонусыңыз көбірек болатынын ескеріңіз.",
    welcoming_title: "Қосымша оқиғалар экспресс қосымша бонустар!"
  },
  commission: "Комиссия:",
  competitionAction: "Осы ойындардың бірін ойнау арқылы турнирге қатысыңыз",
  competitionMembers: "турнир қатысушылары",
  competitionParticipants: "Қатысушылар тізімі осы алаңда көрсетіледі ",
  competitionWinners: "Жеңімпаздар тізімі осы алаңда көрсетіледі",
  competitions: "Барлық турнирлер",
  competitionsGames: "Турнирлік",
  competitors: "{count} турнир қатысушылары",
  completeRegistration: "Тіркелуді аяқтау",
  completeSecuritySettings: "Жеке деректер мен қаражат қауіпсіздік икемдеулерін аяқтаңыз",
  completeSignIn: "Авторизацияны аяқтау",
  completed: "Турнир аяқталды",
  conductError: "Қате",
  confirm: "Растау",
  confirmData: "Деректерді растау",
  confirmInformation: "Ақпаратты растау",
  confirmPersonalData: "Мен жеке деректердің дұрыстығын растаймын және бұл ақпаратты өзгерту мүмкін емес екенін түсінемін",
  confirmPhoneNumber: "Телефон нөмірін растау",
  confirmPhoneThroughTelegram: "Ақшаны қауіпсіз шешу үшін Telegram қосымшасына кіріп, телефон нөміріңізді растаңыз",
  confirmationCode: "Растау коды",
  confirmationEmail: "Email растау",
  confirmationPhone: "Телефонды растау",
  confirmed: "Расталды",
  congratulationsTrustWalletCreated: "Құттықтаймыз! Trust Wallet әмияны жасалды!",
  contact: "хабарласыңыз",
  continueSecuritySetup: "Қауіпсіздік икемдеуіне оралу",
  converting: "автоматты түрде __ айырбасталады",
  copeAddressMemo: "Мемо сәтті көшірілді",
  copeAddressWallet: "Әмиян мекенжайы сәтті көшірілді",
  copeAddressWalletNew: "Әмияныңыздың мекенжайы сәтті көшірілді",
  copeCode: "Код сәтті көшірілді",
  copeSumText: "Сома сәтті көшірілді",
  copy: "Көшіру",
  copyAddress: "Мекенжайды көшіру",
  copyCode: "Кодты көшіру",
  copyTheAddress: "Мекенжайды көшіріңіз",
  countries: {
    bangladesh: "Бангладеш",
    kazakhstan: "Қазақстан",
    kyrgyzstan: "Қырғызстан",
    russia: "Ресей",
    uzbekistan: "Өзбекстан"
  },
  country: "Мемлекет таңдау",
  countryNotFound: "Ел табылмады, жазылған елдің дұрыстығын тексеріңіз",
  countrySelect: "Мемлекет таңдау",
  coupon: "Купон",
  couponContainsDependentOutcomes: "Купонда тәуелді нәтижелер бар",
  createWalletInTrustWallet: "Trust Wallet-те әмиян жасаңыз",
  cryptoMemo: "Мемо",
  cryptoTournament: "Крипто-турнир",
  cryptoWallerSuccessChanged: "Әмиян мекен-жайы сәтті өзгертілді",
  cryptoWallet: "Крипто әмиян",
  cryptocurrency: "Криптовалюта",
  currency: "Валюта",
  current: "Ағымдағы",
  currentBalanceIsLessThanTheWithdrawalAmount: "Кейбір төлем әдістері қолжетімсіз, ағымдағы теңгерім транзакция үшін қажетті минималды сомадан аз",
  currentRates: "Ағымдағы ставкалар",
  customerSupport: "қолдау қызметіне",
  customizeDisplayedCoins: "Көрсетілген монеталарды реттеу үшін жоғарғы оң жақ бұрыштағы жүгірткілерді нұқыңыз, іздеу жолағындағы токендерді қосу бетінде Doge деп теріңіз. Монетаға қарама-қарсы жүгірткіні басу арқылы Doge монетасын іске қосыңыз",
  cyrillicInPasswordNotAvailable: "Парольде кириллица рұқсат етілмейді",
  data: "Kүн",
  dataNotSpecified: "Деректер көрсетілмеген",
  date: "Күні",
  dateFrom: "Күнінен бастап",
  dateOfTransaction: "Транзакция күні",
  dateTo: "Күніне дейін",
  deadline: "Аяқталуына дейін",
  december: "желтоқсан",
  decline: "Кері қайтарылды",
  demo: "Демо",
  deposit: "Депозит\n",
  depositAccount: "Шотты толтыру",
  depositBK: "БК-дан толтыру",
  depositBonus: "толтырымға бонус {bonus}",
  depositForBonus: "Бонусты алу үшін, {sum} сомасынан жоғары толтырым жасаңыз",
  depositNoun: "Толтыру",
  depositRequired: "<span class='bonus-item__sum'>{sum}</span> басталатын депозит салу қажет",
  description: "Сипаттамасы",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Слоттар онлайн ➔ ✓тегін және ✓тіркелусіз ✓ақшаға ойнаңыз. {company} казино ✓жомарт бонустары мен  ✓түрлі тақырыптары\nбар ✓тегін ✓танымал ✓ресми өндірушілерден ✓заманауи ойын автоматтарын ұсынады."
    }
  },
  details: "Толығырақ",
  docsWasApproved: "Құжаттар сәтті тексерілді",
  docsWasDeclined: "Құжаттар тексеруден өтпеді",
  documentAttacheMessage: "Біз оларды 24 сағат ішінде тексереміз. Содан соң барлық төлем әдістері сізге қолжетімді болады.",
  documentAttacheSuccess: "Сіздің құжаттарыңыз сәтті жіберілді.",
  documentDeleteSuccess: "Құжаттар сәтті жойылды",
  documentNumber: "Құжат нөмірі",
  documentUpload: "Құжаттарды жүктеу",
  done: "Дайын!",
  doneThresholdConditions: "Депозитке бәс тігу шарттары орындалды",
  download: "Жүктеу",
  downloadApp: "Колданбаны жүктеп алыңыз",
  downloadOlimpApp: "Olimp қосымшасын жүктеу",
  download_app: "Olymp қосымшасын жүктеу",
  dropswins: {
    eight: "Кездейсоқ уақытта 9000€ сомасына ақшалай жүлделер ұтыс ойыны өтеді. Ұту үшін ойна!",
    eighteen: "Ережелер және шарттар",
    eleven: "Апта сайынғы турнирдің жүлделер кестесі (кәдімгі апталар)",
    fifteen: "Күн сайынғы жүлделер кестесі",
    five: "КҮН САЙЫН",
    four: "ТУРНИР\n",
    fourteen: "Апта сайынғы турнирдің жүлделер кестесі (кәдімгі апталар)",
    nine: "4 х 62 000€ апта сайын турнир",
    nineteen: " 1. Pragmatic Play TM желілік науқаны. Бұл науқан 02.02.2021 бастап 17.11.12021 CET (01.01 11.02.2021 бастап 00:59 18.11.12021 EET) аралығында өтеді <br> 2. Науқан 10 кезеңде өтеді, әр кезең 4 аптаға созылады. <br> 3. Науқанның жалпы жүлде қоры - 4 000 000 €, ол 40 х 62 000 € апта сайынғы турнирлерінен және 40 х 63 000 € апта сайынғы жүлде ұтыс ойынынан тұрады. <br> 4. Төменде осы науқанның 7 -ші кезеңінің шарттары берілген. Турнирдің механикасы кезеңге байланысты өзгеретінін ескеріңіз. <br> 5. Кез келген желілік компанияның турниріне немесе жүлделер ұтыс ойынына қатысу үшін ойыншылар кез келген қатысушы ойындарды ашып, шарттар мен талаптарды растау/келісу қажет. <br> 6. Төрт (4) апталық турнирлер мен жүлделер ұтыс ойыны келесі түрде өтеді: <br> 27 апта: 11/08/2021 20:01 - 18/08/2021 19:59 EET <br> 28 апта: 18/08/2021 20:01 - 25/08/2021 19:59 EET <br> 7. Іріктеу ойындары: <br> Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™ ",
    one: "Әрқайсы жеңімпаз бола алатын Pragmatic Play-дан Drops & Wins желілік турниріне қосыл! ",
    seven: "Жеке айналуда ең көп ұтысқа ие бола отырып, көшбасшылар кестесінің ең жоғарысына көтеріл. ",
    seventeen: "Бұл турнирде ставканың мөлшеріне қарамастан, барлық ойыншылар үшін турнирге қатысу әділ болатындай, ұтыстың көбейткішін есептейтін механизм қолданылады. Мысалы, егер 2€ сомасына ставка қойып, 10€ ұтып алсаң, онда сіздің ұтыстың көбейткіші беске тең. Бұл жағдайда бес ұпай аласың. Жеке айналымда ең жоғары ұтыспен 1200 Үздік көшбасшылар кестесіне көтеріл.",
    six: "Ойындарды ұсыныстарда аш, турнирге қосыл және ойнауды баста! (минималды ставка 0.50 еуро).*",
    sixteen: "Турнирге және жүлделер ұтыс ойынына аутоматты түрде қатысу үшін, науқанға тек бір рет қосылу қажет. ",
    ten: "4 х 62 000€ апта сайын жүлделер ұтыс ойыны",
    thirteen: "Марапат",
    three: "ОЙНА",
    twelve: "Орын",
    twenty: "Апта сайынғы турнирлер",
    twentyfour: "Жылдам кэшбэк",
    twentyone: " 1. Көшбасшылар кестесі ұпайларға негізделеді, ал ұпайлар ставка сомасын ескере отырып, кез келген қатысушы ойынның бір спиннен ең жоғары ұтысы бойынша толтырылады. <br> 2. Көшбасшылар кестесі нақты уақыт режимінде жаңартылады және ойыншылар кез келген уақытта турнирге қатысатын кез келген ойындарды ойнай отырып, көшбасшылар кестесін қарай алады. <br> 3. Егер екі (2) немесе одан да көп ойыншы турнир кестесін көшбасшылар кестесінде бір орында аяқтаған жағдайда, жоғары орын алдымен сол ұпай саны бар ойыншыға беріледі. <br> 4. Жүлделер ойыншыларға белгіленген сома ретінде төленеді. <br> 6. Апта сайынғы жүлде қорында жалпы сомасы 62 000 евро болатын 1200 ақшалай сыйлық бар. <br> 7. ОРНЫ - АПТА САЙЫНҒЫ ЖҮЛДЕЛЕР<br> 1. €10,000<br> 2. €5,000<br> 3. €2,000<br> 4-10. €1,000<br> 11-20. €500<br> 21-50. €200<br> 51-100. €100<br> 101-300. €50<br> 301-600. €20<br> 601-1200. €10 ",
    twentythree: " 1. Науқанның әр апта барысында күнделікті жеті (7) ұтыс ойыны жүргізіледі. <br> 2. Әр науқан кезінде шарттарға сай бір (1) спин жүлде қорынан бір (1) жүлдеге ие бола алады. <br> 3. Сыйлықтар кездейсоқ түрде ойнатылады. Ережелер мен жүлделер кестелері турнирде қатысатын ойындарда қолжетімді. Жүлде кестесі нақты уақытта жаңартылады, онда ағымдағы позиция және қалған жүлделер саны көрсетіледі. <br> 4. Жүлделер турнирде қатысатын әр ойынның әр қайсысында Жүлделер бөлімінде көрсетілгендей төленеді. <br> 5. Жүлделер ойыншыларға белгіленген сома ретінде төленеді. <br> 6. Жүлде ұтыс ойынына қатысу үшін турнирге қатысатын ойын(дар)-ға 0,50 еуро мөлшеріндегі нақты ақшалай ставка жасау қажет. Бір ойыншы әр күн ішінде бірнеше сыйлық ұтып алу мүмкін. <br> 7. Жүлделердің ұтыс ойыны күн сайын (i) 00:59 EEST / EET немесе (ii) барлық сыйлықтар берілгеннен кейін аяқталады (қайсысы бірінші келеді). <br> 8. Егер белгілі бір күн сайынғы ұтыс ойынының жүлде қоры толық бөлінбесе, онда кез келген артық қаражат PragmaticPlay ™ қалауы бойынша келесі кезеңдегі жүлде қорына аударылады. <br> 9. Апта сайынғы жүлде қоры жалпы сомасы 63 000 € құрайды, ал күнделікті жүлде қорында 500 ақшалай сыйлық пен жалпы 9 000 € сомасына тегін айналымдар бар. <br> <br> 10. Саны - Күнделікті сыйлықтар <br> 1 X € 1000 <br> 2 X € 500 <br> 5 X € 100 <br> 12 X € 50 € 110 X € 20 € 370 X € 10 <br> 11. Жеңімпаздар өз сыйлықтарын ақшалай түрде алады. Ақшалай сыйлықтар турнир аяқталғаннан кейін {baseLink} казиносындағы ойын шоттарына автоматты түрде түседі. <br> 12. {baseLink} науқанның шарттарын кез келген уақытта өзгерту немесе жою құқығын өзіне қалдырады. <br> 13. {baseLink} жалпы ережелері қолданылады. ",
    twentytwo: "Апта сайынғы жүлделер ұтыс ойыны",
    two: "500 000€ мөлшерінде жүлде қоры кезеңдер арасында бөлінген - аптасына 125 000€!  Қатысу үшін, келесі қадамдарды орында!"
  },
  email: "Email",
  emailNeedValid: "Электрондық поштаға растау коды жіберіледі",
  emailSuccessfullyApproved: "Электрондық пошта сәтті расталды",
  emptyGames: "Біз сізге мұндай ойындарды таппадық",
  emptyPromoPage: "Ағымдағы науқандар осы бөлімде көрсетіледі",
  ended: "Аяқталды",
  engineeringWorks: "5 минуттан кейін техникалық жұмыстар жүргізілетін болады",
  english: "Ағылшын",
  enter: "Қосылу",
  enterCode: "Кодты енгізіңіз",
  enterCodeFromEmail: "Электрондық поштаға жіберілген кодты енгізіңіз",
  enterCorrectPhoneNumber: "Жарамды телефон нөмірін енгізіңіз",
  enterCryptoWallet: "Крипто әмиянды енгізу",
  enterCryptoWalletOnProfilePage: "Ұтысты алу үшін жеке кабинетте Doge крипто әмиянын енгізіңіз",
  enterGameName: "Ойынның атын енгізіңіз",
  enterGameNameOrProvider: "Ойынның немесе провайдердің атын енгізіңіз",
  enterMoreCharacters: "Көбірек таңбалар енгізіңіз",
  enterPromoCode: "Промокодты енгізіңіз",
  enterSMS: "SMS -тен кодты енгізіңіз",
  enterSixDigitCode: "Қолданбадан 6 таңбалы кодты енгізіңіз",
  enterValidEmail: "Дұрыс электрондық поштаны енгізіңіз",
  enterWalletAddress: "Doge крипто әмиянының мекенжайын қазір немесе кейін енгізіңіз, оған турнир ұтысы аударылады.",
  enterYourBankCardDetails: "Банк картасының мәліметтерін енгізіңіз, төлем жүйесінің шарттарымен келісіңіз және «Төлеу» батырмасын басыңыз",
  entrance: "Кіру",
  err404subtitle: "Сені негізгі парақшада күтеміз!",
  err404title: "Өкінішке орай, ештеңе табылмады…",
  error: "Қате",
  errorPasswordField: "Пароль сандарды, бас әріптерді және кіші әріптерді қамтуы тиіс",
  errorPaymentDataInitialization: "Төлем жүйесін инициализациялау кезіндегі қате",
  errorPaymentUrlInitialization: "Төлемді инициализациялау кезіндегі қате",
  errorWhileSendingCode: "Коды бар хабарландыруды жіберу сәтсіз аяқталды, кодты қайта сұрап көріңіз",
  errorsWhileValidate: "Нысанды валидтеу кезіндегі қателер",
  euro_slot: {
    description: "Euro Slots 2024-ті тек {platform} сында онлайн ойнау - үздік ресми ойын слоттары. Онлайн казинода тегін және ақшаға ойна.",
    end: "Турнир аяқталды",
    "final": "Финалға өт",
    inProgress: "Матч жалғасуда",
    mathPrize: "Матчтың жүлде қоры:",
    onWallet: "шотқа",
    prize: "Жалпы жүлде қоры:",
    "prize-short": "ЖҮЛДЕ",
    prizeFond: {
      "1\/2": "1/2 финалдың <p>жүлде қоры:</p>",
      "1\/4": "1/4 финалдың <p>жүлде қоры:</p>",
      "1\/8": "1/8 финалдың <p>жүлде қоры:</p>",
      "final": "Финалдың <p>жүлде қоры:</p>"
    },
    rules: {
      "1": "Aksiya 13.06.2024 00-00 GMT +5 dan 14.07.2024 00-00 GMT + 5 gacha o'tkaziladi",
      "2": "Turnirning umumiy sovrin jamg'armasi: {sum}",
      "3": "Кестеге сәйкес турнир торында қозғалатын слоттар арасында шайқас өткізіледі",
      "4": "Белгілі бір науқан ойынының жеңісіне ең үлкен үлес қосқан пайдаланушылар жүлде қорын өзара бөліседі",
      "5": "1/8 кезең жұптарына арналған күндер ({sum}):",
      "6": "1/4 кезең жұптарына арналған күндер ({sum}):",
      "7": "1/2 кезең жұптарына арналған күндер ({sum}):",
      "8": "Финал күндері ({sum}):",
      "9": "Жүлделер 24 сағат ішінде ойын шотына автоматты түрде түседі"
    },
    stage1: "<span>Тіркел</span> және \"ҚАТЫСУ\" батырмасын бас.",
    stage2: "<span>Турнирге қатысатын ойындардың кез келгеніне ставка жаса</span> және ұпайлар жина.",
    stage3: "<span>Үздік ойыншы</span> жалпы жүлде қорын бөліседі",
    stages: {
      "1\/2": "1/2 финал",
      "1\/4": "1/4 финал",
      "1\/8": "1/8 финал",
      "final": "финал"
    },
    stagesAtStart: {
      "1\/2": "Финалдың басталуына дейін:",
      "1\/4": "1/2 финалдың басталуына дейін:",
      "1\/8": "1/4 финалдың басталуына дейін:",
      "final": "Финал",
      pre: "1/8 финалдың басталуына дейін:"
    },
    start: "Қалай қатысуға болады",
    table: "Турнир кестесі",
    title: "Euro Slots 2024 турнирі - {platformSite} онлайн казино слоттарын ойнау",
    winners: "Турнир жеңімпаздары"
  },
  events: "Оқиғалар",
  exchangeRateInTenge: "Теңгедегі валюта бағамы",
  exit: "Шығу",
  express: "Экспресс",
  expressCoef: "Экспресстің коэффициенті",
  expressSystem: "Экспресстер жүйесі",
  failed: "Әрекет жасалмады",
  fastBet: "Жылдам ставка",
  fastbetDetailedDescription: "Жылдам ставка сізге екі клик арқылы дара ставкаларды жасауға мүмкіндік береді. Соңғы жасалған ставканың сомасын есте сақтау ставка жасау процесін одан әрі жылдамдатады.",
  fastbetSetting: "Жылдам ставка икемдеулері",
  fastbetSum: "Жылдам ставка сомасы",
  favorite: {
    added: "Ойын таңдаулылар тізіміне қосылды",
    removed: "Ойын таңдаулылардан алынып тасталды"
  },
  favorites: "Таңдаулылар",
  february: "ақпан",
  fieldRequire: "Толтыруға міндетті алаң",
  fileAttached: "Файл тіркелді",
  fileNotAttached: "Файл тіркелмеді",
  fillInformation: "Ақпаратты толтыру",
  fillProfileInfoForWithdraw: "Шоттан шығару үшін жеке мәліметтеріңізді толтыруыңызды өтінеміз.",
  fillRequiredInfoBelow: "Төменде қажетті ақпаратты толтыруыңызды сұраймыз",
  filter: "Сүзгі",
  filterByDate: "Күні бойынша сүзгі",
  filtersText: {
    inTheNextSixHours: "таяу 6 сағатта",
    inTheNextTwentyFourHours: "таяу 24 сағатта",
    inTheNextTwoHours: "таяу 2 сағатта",
    nextThreeDays: "таяу 3 тәулікте",
    nextTwelveHours: "таяу 12 сағатта",
    nextWeek: "таяу 1 аптада",
    today: "Бүгін",
    tomorrow: "Ертең",
    whenever: "кез келген уақытта"
  },
  findOutAddressOfDogeWallet: "Doge әмиянының мекенжайын біліңіз",
  fine: "Жақсы",
  firstAuthMessage: "Телефон нөміріне логин мен пароль көрсетілген SMS жіберілді. Шотты толтырыңыз және бірінші ұтыстарды алуға аттаныңыз",
  firstDeposit: "Бірінші депозитке!",
  forCorrectGamePushRefresh: "Ойынның дұрыс көрсетілуі үшін, жаңарту батырмасын басыңыз",
  forEndCompetition: "Турнир аяқталғанға дейін",
  forMoreInformation: "Қосымша ақпарат алу үшін",
  forStartCompetition: "Турнир басталғанға дейін",
  forgotPassword: "Парольді қалпына келтіру",
  fraud: "AML саясаты",
  freeBetsButton: "Танысу",
  freeBetsCount: "Қол жетімді фрибеттер:",
  freeBetsStepFour: "Ставка жасаңыз",
  freeBetsStepOne: "«Спорт» бөлімін ашыңыз",
  freeBetsStepThree: "Оқиғаны таңдаңыз",
  freeBetsStepTwo: "Купондағы «Фрибетті» белсендіріңіз",
  freeBetsTitle: "Спортқа «фрибет»",
  freeSpinsInGame: "Free Spins ойында",
  freespin: "Тегін айналдыру",
  freespinsAvailable: "Тегін айналдыру қолжетімді",
  from: "{date} бастап",
  fromAnySum: "Кез келген сомадан",
  fromNumber: "бастап",
  fromSmth: "{value} бастап",
  fulfillConditionsForWithdrawal: "Қаражатты шешудің барлық шарттарын орындаңыз.",
  fund: "Жүлде қоры",
  future: "Келешек",
  game: "Ойын",
  gameDescTemplate: "{gameName} ойын автоматы — {providerName} танымал әзірлеушіден онлайн слот. {gameName} ойын автоматын тегін ойнаңыз немесе ақшаға ойнау үшін тіркеліңіз",
  gameForMoneyOnlyForAuthUser: "Ақшаға ойын тек авторизацияланған пайдаланушыларға қолжетімді",
  gameInOtherTab: "Ойын басқа парақшада ашық",
  gameNotAvailableBonus: "Ойын бонус шарттарына байланысты қолжетімсіз",
  gameNotAvailableGeoRestriction: "Ойын сіздің аймағыңызда қолжетімсіз",
  gameNotFound: "Ойын табылмады",
  gameTitleTemplate: "{gameName} ойын автоматы. {company} онлайн казинода тегін ойнау",
  gameUnavailable: "Ойын уақытша қолжетімді емес",
  game_categories: "Ойын категориялары",
  games: {
    tryOther: "Басқа ойындарды көріңіз"
  },
  gamesNotFound: "Ойындар табылмады",
  geoRestrictionDesc: "Өкінішке орай, бұл ойын сіздің аймағыңызда қолжетімсіз.",
  geoRestrictionDescLine2: "Каталогтан басқа ойын таңдауды ұсынамыз",
  get: "Алу",
  getBonus: "Бонус алу",
  getBonusByPromoCode: "Бонусты промокод бойынша алу",
  getGainFromFreeSpins: "Фриспиндерден ұтқан соманы алу",
  getNewCode: "Жаңа кодты алу",
  getSMS: "SMS кодын алу",
  go: "Өту",
  goBack: "Артқа қайту",
  goToGame: "Ойынға өтіңіз",
  goToGames: "Ойындарға өту",
  goToHome: "Басты парақшаға оралу",
  goToOlimpCasinoAndPlayFavoriteGames: "Olimp Casino-ға өтіп, сүйікті ойындарыңызды ойнаңыз:)",
  goToVolet: "volet.com (adkash) сайтына өтіңіз",
  goToWallet: "Әмиянға өтіңіз",
  goesNow: "Қазір өтуде",
  gold: "Алтын",
  guarantee: {
    five: "Ойыннан үзіліс алу. Егер ойнауға деген ықыласты азайту үшін біздің казино қолдау қызметіне логиніңізді құлыптау мақсатымен хабарлассаңыз, сіздің өтінішіңіз орындалады. Ойыншының профилін біржола жою мүмкіндігі бар. Басқа жағдайда, ойыншының қалауы бойынша оны біраз уақыттан кейін қалпына келтіруге болады.",
    four: "Ойынға жеке кіруді шектегісі келетін ойыншылар үшін келесі нұсқалар әзірленді:",
    one: "Жауапты ойын",
    seven: "Кіруді шектеу. Егер өзіңізді құмар ойындарын ұсынатын немесе жарнамалайтын әртүрлі сайттардан қорғағыңыз келсе, арнайы бағдарламалық жасақтаманы пайдалануыңыз қажет. Ол сүзгілеу жүйелерін жасайды және құмар ойындарға тәуелді қолданушылар үшін қауіпсіз онлайн режимін қамтамасыз етеді. Сонымен қатар, бағдарламалық жасақтама балалардың қалаусыз ресурстарға қол жеткізуіне жол бермеу үшін қолданыла алады. Бағдарламалық жасақтаманың мысалдары: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).",
    six: "Мамандандырылған көмек. Егер құмар ойынға тәуелділік дамыса, ойыншылар білікті мамандардың көмегіне жүгіне алады. Сіз мына жерден көмек ала аласыз: Gamblers Anonymous (www.gamblersanonymous.org.uk) - ойынға тәуелді ойыншыларға көмектесетін, аноним ойыншылардың халықаралық қауымдастығы; GamCare (www.gamcare.org.uk) - ойыншыларға тәуелділіктен арылуға көмектесетін ағылшын тілінде сөйлейтін ұйым; Gambling Therapy (www.gamblingtherapy.org) - жалпы аурумен күресте білікті қолдау көрсететін Ұлыбританияда орналасқан ұйым.",
    three: "Егер сіз құмар ойынына аздап тәуелді болсаңыз, алдымен сіз үшін құмар ойынның не екенін біліп алыңыз. Егер ойын өмірдегі қиындықтардан қашуға әрекет болса, сіздің бос уақытыңыздың барлығын алып, жұмысыңызға кедергі келтірсе, бұл бірінші қоңырау болып табылады. Егер сіз ойнау үшін қарызға ақша алып, онсыз өз күніңізді елестетпесеңіз, бұл сізге күрт өзгерістер қажет екендігінің сенімді белгісі.",
    two: "{titlePure} сайтта ойнайтын пайдаланушыларға қатысты белгілі бір жауапкершіліктерге ие. Казино әкімшілігі ойыншыларға ойынға тәуелділік пайда болуының мүмкін салдарынан құтылуға көмектесуге дайын. Ойынның мәні жағымды эмоцияларды және қуаныш жеткізу. Әрине, сәтсіздіктер болуы мүмкін, бірақ бұл ешқандай жағдайда қаржылық немесе әлеуметтік қиындықтар тудырмауы керек."
  },
  hasMinimalDeposit: "Минималды депозит салынды",
  haveActivatedFastbetMode: "Сіз жылдам ставка режимін белсендірдіңіз. Ережелермен танысу үшін батырмаға басыңыз",
  haveNotEmailContactUs: "Егер электрондық поштаға хат келмесе, «Спам» және «Промо науқандар» папкаларын тексеріңіз немесе {0} хабарласыңыз",
  haveNotPhoneContactUs: "Телефон нөміріңізге SMS келмесе, {0} хабарласыңыз.",
  here: "Осында",
  hiddenConditions: "Жасырын шарттар",
  hide: "Жасыру",
  hideBonusCondition: "Бонус шарттарын жасыру",
  hideDetails: "Егжей-тегжейді жасыру",
  history: "Тарих",
  historyBets: "Ставкалар тарихы",
  historyPayments: "Транзакциялар тарихы",
  historyTransactions: "Транзакциялар тарихы",
  hotGame: "Ыстық",
  hotGames: "Ыстық ойындар",
  hotToBuyCryptoCurrency: "Криптовалютаны қалай сатып алуға болады?",
  howCanBuyCryptocurrency: "Криптовалютаны қалай сатып алуға болады? ",
  howCreateCryptoWallet: "Крипто әмиянды қалай ашуға болады? ",
  howCreateWallet: "Әмиянды қалай ашуға болады?",
  howToCreateCryptoWallet: "Крипто әмиянды қалай ашуға болады?",
  howToFindOutWalletNumber: "Әмиян нөмірін қалай білуге болады?",
  howToInstallApp: "Қосымшаны қалай орнатуға болады?",
  howToViewMyCryptoWalletInOlimp: "Олимпте менің крипто-әмиянымды қалай көруге болады?",
  howTopUp: "Қалай толтыруға болады",
  howTransferCrypt: "Криптовалютаны қалай аударуға болады",
  howTransferCryptStep1: "Әмиянға немесе биржаға кіру",
  howTransferCryptStep2: "Таңдалған тиынды табу {currency}",
  howTransferCryptStep3: "Әмиянымыздың мекенжайын енгізу",
  howTransferCryptStep4: "Соманы көрсету және жіберу",
  iPaid: "Мен шотты толтырдым",
  idWasCopied: "Сіз транзакцияның id нөмірін көшірдіңіз",
  inSettings: "икемдеулерде",
  information: "Ақпарат",
  informationConfirmWithdraw: "Ақшаны алу және қауіпсіздік үшін барлық деректеріңізді растаңыз. Электрондық пошта мекен-жайын немесе телефон нөмірін өзгерту үшін ___ хабарласыңыз",
  informationConfirmWithdrawSupport: "қолдау қызметіне",
  informationForUpdateProfileData: "Байланыс ақпаратын жаңарту үшін қолдау қызметіне хабарласу қажет",
  installApp: "қосымшаны орнату үшін {0}",
  installTrustWalletApp: "Trust Wallet қолданбасын орнатыңыз",
  instant: "Жылдам",
  instantCash: "Cashback",
  instantCashback: "Жылдам cashback",
  instantWithdrawal: "Жылдам шешу",
  instantly: "Лезде",
  insufficientFundsAvailable: "Қаражат жеткіліксіз. Қолжетімді:",
  invalidCryptoWallet: "Қате әмиян мекен-жайы",
  invalidDateFormat: "Күн форматы жарамсыз",
  invalidDateInterval: "Таңдалған интервал қате",
  invalidStartDate: "Бастапқы күн қате",
  iosWebAppInstruction: "iOS нұсқаулығы",
  jackpot: "Джекпот",
  jackpotGame: "Джекпотпен",
  january: "қаңтар",
  july: "шілде",
  june: "маусым",
  kazakh: "Қазақша",
  kycPolicy: "KYC саясаты",
  latestGames: "Соңғы ойындар",
  leftCount: "{count} қалды",
  leftDeposit: " {sum} толтырым жасау қалды",
  licenseCuracao: "Содержимое веб-сайта принадлежит и управляется Perantia N.V. (<a href='https://olimp.com' target='_blank'>olimp.com</a>) в качестве держателя лицензии (лицензия Кюрасао № 365/JAZ). Все права защищены и охраняются законом.",
  lineOn: "{date} арналған желі",
  linkIsReady: "Сілтеме дайын",
  liveCashBackDesc: "{company} біздің VIP клиенттерімізге ғана қолжетімді эксклюзивті бонус ұсынады! «LIVE Casino» санатындағы ойындарға ставкалар жасаңыз және ұтылған ставкалар сомасына байланысты шотыңызға Cashback сомасына ие болыңыз!",
  liveCashback: "Live cashback\n",
  liveCashbackHistory: "Live cashback тарихы",
  live_casino: "LIVE Казино",
  loading: "Жүктеу",
  loadingLanguage: "Тіл жүктелуде",
  lobby: "Негізгі парақша",
  login: "Логин\n",
  loginCopied: "Сіздің логиніңіз көшірілді",
  loginErr: "{name} логинінде әріптер болмау қажет!",
  loginTelegram: "Telegram арқылы кіру",
  logoutFromSystem: "Шығу",
  lose: "Жеңіліс",
  losers: "Ұтылғандар",
  lottery: "Лотерея",
  mainPage: "Негізгі парақша",
  makeABet: "Ставка жасау",
  makeBet: "Ставка жасау",
  makeDeposit: "Толтыру",
  march: "наурыз",
  matchClosed: "Матч жабық",
  matchEnded: "Матч аяқталды",
  matchNotFound: "Матч табылмады",
  matchPlanned: "Матч жоспарлануда",
  matches: "Матчтар",
  maxBet: "Максималды ставка",
  maxForExpress: "Экспресс үшін максимум",
  maxLength: "Өрістің максималды ұзындығы {length}",
  maxOutput: "Ақша шешудің минималды сомасы",
  maxPay: "Максималды төлем сомасы",
  maxSum: "Макс. сома",
  maxValue: "Максималды мән {value}",
  maxValueShort: "Макс: {value}",
  maxWithdrawSum: "Ақша шешудің максималды сомасы",
  maximumPayment: "Максималды төлем сомасы:",
  may: "мамыр",
  messageSMS: "SMS-тен кодты енгізіңіз",
  messages: "Жаңа хабарламалар",
  middleName: "Әкесінің аты",
  minBet: "Минималды ставка",
  minDepositForBonus: "Қадамды аяқтау үшін кемінде {sum} толтырым жасаңыз",
  minLength: "Өрістің минималды ұзындығы {length}",
  minLengthPassword: "Парольдің минималды ұзындығы {min} таңба",
  minOutput: "Шығарудың минималды сомасы",
  minPay: "Минималды төлем сомасы",
  minSum: "Мин. сома",
  minValue: "Минималды мән {value}",
  minValueShort: "Мин: {value}",
  minimalDeposit: "Минималды депозит",
  minimalLengthOfCode: "Кодтың минималды ұзындығы {num} таңба",
  minimalSum: "Минималды сома",
  minimumPayment: "Минималды төлем сомасы:",
  minimumTransfer: "Шотқа аударудың минималды сомасы:",
  modal_telegram: "Біздің арнада сен белсенді бонустарды, апта сайынғы ұтыс ойындарды және т.б. таба аласың және бот арқылы сайтқа кіру мүмкіндігін ешқашан жоғалтпайсың!",
  more: "Көбірек",
  moveToBonus: "Бонусқа өту",
  moveToMessages: "Хабарламаларға өту",
  myBalances: "Менің баланстарым",
  myBonuses: "Менің бонустарым",
  name: "Атауы",
  namePerson: "Аты",
  nameTheCheckout: "Әмиян мекен-жайын кассирге жариялаңыз",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "BetGames",
    fantasy: "Fantasy",
    fast: "Жылдам",
    jetx: "JetX",
    line: "Желі",
    live: "Live",
    liveGames: "LiveGames37",
    lottery: "Лотерея",
    online: "Live Казино",
    slot: "Слоттар",
    sportGames: "Sport games",
    table: "Үстел үсті",
    turboGames: "Turbo Games",
    vSport: "V-Sport",
    virtualGames: "Виртуалды ойындар",
    worldcup: "ӘЧ-2022"
  },
  navLinks: {
    bonuses: "Бонустар",
    home: "Басты",
    homeCasino: "Казино",
    posts: "Хабарламалар",
    profile: "Профиль\n",
    promo: "Акциялар",
    sport: "Спорт",
    tournament: "Турнирлер"
  },
  needConfirmProfileInformation: "Бонусты белсендіру үшін профильдегі ақпаратыңызды растаңыз",
  needDeposit: "Толтырым жасау қажет",
  needSettingsSecurity: "Қауіпсіздік икемдеулерін өту қажет",
  needToExecuteConditions: "Шарттарды орындау қажет",
  never: "Ешқашан",
  "new": "Жаңа",
  new2: "Жаңа",
  newBonusAvailable: "Сізге жаңа бонус қолжетімді",
  newGame: "Жаңа",
  newMessage: "Жаңа хабарлама",
  newMessages: "Жаңа хабарлама",
  newOne: "Жаңа",
  newVersionReloadPage: "Сайт нұсқасы жаңартылды, дұрыс жұмыс істеу үшін бетті жаңартыңыз",
  newYearPromocodes2025: {
    NY25DAY1: "Santa's​ ​Gift​ ​ойынында​ ​50​ ​FS",
    NY25DAY10: "Спортқа​•​фрибет!",
    NY25DAY11: "Santa's​ ​Great​ Gifts​ ойынында​ 50​ FS",
    NY25DAY12: "Royal​ Xmass​ ​2​ ​ойынында​ ​75​ FS",
    NY25DAY13: "Депозитке​ 75%​ және​ сыйлыққа​ ​75​ FS!",
    NY25DAY14: "Santa's​ Xmas​ ​Rush​ ​ойынында​ ​100​ ​FS",
    NY25DAY2: "Спортқа​•​фрибет!",
    NY25DAY3: "Депозитке​ ​50% және​ ​сыйлыққа​ ​50​ ​FS!",
    NY25DAY4: "Buffalo​ ​Power:​ ​Christmas​ ойынында​ 75​ ​FS",
    NY25DAY5: "Депозитке​ 75%​ және​ сыйлыққа​ 75​ FS!",
    NY25DAY6: "Royal​ ​Xmass​ ​ойынында​ ​75​ FS",
    NY25DAY7: "Депозитке​ 100%​ ​және​ сыйлыққа​ ​100​ FS!",
    NY25DAY8: "Sugar​ Rush​ Xmas​ ойынында​ 100​ ​FS",
    NY25DAY9: "Депозитке​ ​50%​ және​ ​сыйлыққа​ 50​ FS!"
  },
  next: "Әрі қарай",
  nextGames: "Толығырақ",
  no: "Жоқ",
  noAccount: "Аккаунт жоқ",
  noBetsInHistory: "Сіздің тарихыңызда ставкалар жоқ",
  noConnectionTryAlready: "Интернет байланысы жоқ. Интернетке қосылып, әрекетті қайталаңыз.",
  noDeposit: "Депозитсіз",
  noFavoritesYet: "Таңдаулылар әлі жоқ",
  noMatchSelected: "Бір де бір ойын таңдалған жоқ не желіде оқиғалар жоқ!",
  noResults: {
    bets: "Сіздің ставкаларыңыз осы жерде көрсетіледі",
    bonuses: "Қолжетімді бонустар осы жерде көрсетіледі",
    competitions: {
      active: "Белсенді турнирлер осы жерде көрсетіледі",
      all: "Белсенді турнирлер осы жерде көрсетіледі",
      ended: "Өткен турнирлер осы жерде көрсетіледі",
      future: "Болашақ турнирлер осы жерде көрсетіледі"
    },
    gamesNotFound: "Ойындар табылмады",
    gamesSearch: "Сіздің сұранысыңыз бойынша ойындар табылмады, басқа сұранысты қолданып көріңіз",
    messages: "Сіздің хаттамаларыңыз осы жерде көрсетіледі",
    payin: "Сізде қолжетімді толтыру әдістері жоқ",
    payout: "Сізде қолжетімді ақша шешу әдістері жоқ",
    simple: "Нәтиже жоқ",
    transactions: "Сіздің транзакцияларыңыз осы жерде көрсетіледі",
    withdraw: "Ақша шығаруға сауалдарыңыз осы жерде көрсетіледі"
  },
  noSelectionsForBetting: "Ставка үшін нәтижелер таңдалған жоқ",
  nomination: "Турнир номинациясы",
  nonBonusGame: "Ойын бонустық бағдарламаға қатыспайды. Шотыңызды негізгі шотқа ауыстырамыз.",
  nonBonusGameBetsNotCountInVager: "Ойын бонустық бағдарламаға қатыспайды. Ставкалар бонус вейджерінде есепке алынбайды",
  nonBonusGameWithoutBalance: "Ойын бонустық бағдарламаға қатыспайды. Ойнау үшін негізгі шотты толтырыңыз.",
  notBonuses: "Қазір белсенді бонустар жоқ",
  notCompetition: "Қазір белсенді турнирлер жоқ",
  notConfirmed: "Расталған жоқ",
  notDeposit: "Ешқандай толықтырулар болған жоқ",
  notEnoughEventsForExpress: "Экспресс үшін оқиғалар жеткіліксіз",
  notEnoughEventsForSystem: "Жүйе үшін оқиғалар жеткіліксіз",
  notEnoughMoneyToWithdraw: "Қаражат шешуге ақша жеткіліксіз",
  notEnoughVventsForSystem: "Жүйе үшін оқиғалар жеткіліксіз",
  notInterested: "Қызық емес",
  notLogin: "{name} логиніңізді енгізіңіз!",
  notNow: "Қазір емес",
  notPass: "Парольді еңгізіңіз!",
  notSufficient: "жеткіліксіз",
  notValidValue: "Қате мән",
  notification: "Хабарландыру",
  november: "қараша",
  nowInLine: "Қазір желіде",
  nowPlayed: "Қазір ставка жасалды",
  numberErr: "Тіркелу кезінде белгіленген нөмірді тексеріңіз",
  numberOfWallet: "Әңгiме нөмiрi",
  october: "қазан",
  onAccountBK: "БК шотында",
  oneClick: "Банкті бір клик арқылы көбейт",
  online: "Онлайн",
  onlyForYou: "Тек сіз үшін",
  open: "Ашу",
  openAppTrustWallet: "Қолданбаны ашыңыз және сізге екі мүмкіндік қолжетімді болады – жаңа әмиянды тіркеу немесе бар әмиянды қалпына келтіру. «Жаңа әмиян жасау» батырмасын басыңыз",
  openEmail: "Электрондық поштаны ашу",
  openGameNewTab: "Ойынды ашу үшін түймені басыңыз",
  openSafari: "Safari-ден ашыңыз",
  openSafariIfAnotherBrowser: "Егер сіз басқа браузерде болсаңыз, бұл парақшаны Safari браузерінен ашыңыз",
  openTelegramBot: "Телеграм-ботты ашу",
  operations: "Операциялар",
  orders: "Тапсырыстар",
  ordinary: "Дара ставка",
  ordinarySeries: "Дара ставкалар сериясы",
  other: "Басқа",
  otherSections: "Басқа бөлімдер",
  ourSocialMedia: "Біздің әлеуметтік желілер",
  ourSocialMediaShort: "Біздің әлеум. желілер",
  out: "Шығу",
  output: "Шешу",
  outputModalTitle: "Ақша алуды растау",
  outputSuccess: "Шығару сәтті аяқталды!",
  overallCoef: "Жалпы коэффициент",
  page: "Бет",
  pageErr: "Парақша табылмады",
  pageErrDesc: "Парақша жойылған немесе мекенжай қате енгізілген",
  pageNotFound: "Парақша табылмады!",
  pageNotFoundDesc: "Парақша жойылған немесе мекенжай қате енгізілген",
  participant: "Қатысушы",
  participate: "Қатысу",
  passErr: "Парольді қалпына келтіру",
  passMessage: "Пароль сандар, үлкен және кіші әріптерден тұру қажет",
  passportIndex: "Төлқұжат нөмірі / ID",
  password: "Пароль\n",
  passwordChanged: "Пароль өзгертілді",
  passwordErr: "Тіркелу",
  passwordNew: "Жаңа пароль",
  passwordSuccess: "Пароль сәтті түрде қалпына келтірілді",
  passwordTheSame: "Құпиясөз қолданыстағы құпиясөзден ерекше болуы тиіс",
  past: "Өткен",
  pay: "Төлем",
  payBonusErr: "Бонус сатып алу үшін, кемінде келесі сомаға толтыру жасау қалды",
  payMethod: "Толтыру әдісі",
  payMethods: "Толтыру әдістері",
  paymentMethod: "Төлем тәсілі:",
  paymentSuccess: "Ақша аударымы сәтті аяқталды!",
  payoutPayTrxsExistsText: "Қаражатты алу үшін кем дегенде бір толтыру жасау қажет",
  payoutThresholdStatusText: "Қаражатты алу үшін {count} сомасына ставка жасау қажет",
  period: "Кезең",
  personInformationIsApprove: "Деректер қабылданды, аккаунт қорғалды",
  personalArea: "Жеке кабинет",
  personalData: "Жеке деректер",
  personalDataApproved: "Жеке мәліметтер расталды",
  personalDataIsFilled: "Жеке мәліметтер толтырылды",
  personalDataSuccessfullyEdited: "Сіздің жеке деректеріңіз сәтті өзгертілді",
  phone: "Телефон\n",
  phoneErr: "Телефон нөмірінде әріптер болмау қажет!",
  phoneNum: "Телефон нөмірі",
  phoneSuccessfullyApproved: "Телефон сәтті расталды",
  pickUpBonus: "Бонусты алу",
  place: "Орын",
  placeAQuickBet: "Жылдам ставканы қою қажет пе?",
  places: "Жүлделі орындар",
  placesCount: "{count} орын",
  placesPrice: "Жүлделі",
  play: "Ойнау",
  playAviator: "Авиатор ойна",
  playBonus: "Құттықтаймыз, сіз бонусты ұтып алдыңыз! Ақшаны алу {count} сомасынан көп теңгерім толтырғаннан кейін қолжетімді болады",
  playBonusEnded: "Бонус аяқталды. Ойынды жалғастыру үшін есеп шотыңызды {count} сомасына толтырыңыз.",
  playForMoney: "Ақшаға ойнау",
  playGamesInCategoryes: "Санаттар бойынша ойындарды ойнаңыз",
  playWithoutBonus: "Бонуссыз ойнау",
  playingInAppMoreConvenient: "Қосымшада ойнау ыңғайлырақ",
  pleaseConfirmAgreementToTheTerms: "Шарттармен келісетініңізді растаңыз",
  pleaseConfirmInformation: "Ақпаратты растауыңызды сұраймыз",
  pleaseSelectOutcome: "Нәтижені таңдау қажет",
  pleaseUseNumberOfCharacters: "{num} таңба пайдалану қажет",
  point: "Ұпайлар",
  points: "ұпай жоқ | {n} ұпай | {n} ұпай | {n} ұпай",
  postSMS: "SMS кодын жіберу",
  posts: "Хабарламалар",
  potentialWin: "Потенциалды ұтыс",
  ppenFullBetHistory: "Толық ставкалар тарихын ашу",
  preparedForRemoval: "Шешуге дайындалды (өңделуде)",
  preview: "Алдын-ала қарау",
  prize: "Жүлде",
  prizes: "Жеңімпаздардың жүлделері",
  proceed: "Жалғастыру",
  processDeposit: "Толтыруды өңдеу",
  processDepositDescription: "Төлем жіберілді және төлем жүйесі жағынан өңделуде. Қаражаттың аударылуы бірнеше минуттан бірнеше күнге дейінгі уақытты алуы мүмкін",
  processWagerFromBonusBalance: "Бонус теңгерімінен вэйджерді орындау",
  processWagerFromDeposit: "Депозит сомасынан вэйджерді орындау",
  processed: "Өңделуде",
  processing: "Өңделуде",
  promo: "Акциялар",
  promoCodeActivationSuccess: "Промокод сәтті белсендірілді",
  promoGames: "Бонус ойындары",
  promoMaxBetExceeded: "{bet}{currency} ақша шешу шарттарын орындауға пайдаланылатын максималды ставка сомасы",
  promoNotFound: "Қолданыстағы науқандар жоқ",
  promocode: {
    activate: "Промокодты белсендіру",
    placeholder: "Промокод",
    title: "Промокод белсендірілуі"
  },
  promocodes: {
    NY25DAY1: "Santa's Gift ойынында 50 FS",
    NY25DAY10: "Santa's Great Gifts ойынында 50 FS",
    NY25DAY11: "Спортқа фрибет!",
    NY25DAY12: "Royal Xmass 2 ойынында 75 FS",
    NY25DAY13: "Депозитке 75% және сыйлыққа 75 FS!",
    NY25DAY14: "Santa's Xmas Rush ойынында 100 FS",
    NY25DAY2: "Депозитке 50% және сыйлыққа 50 FS!",
    NY25DAY3: "Спортқа фрибет!",
    NY25DAY4: "Buffalo Power: Christmas ойынында 75 FS",
    NY25DAY5: "Депозитке 75% және сыйлыққа 75 FS!",
    NY25DAY6: "Royal Xmass ойынында 75 FS",
    NY25DAY7: "Депозитке 100% және сыйлыққа 100 FS!",
    NY25DAY8: "Sugar Rush Xmas ойынында 100 FS",
    NY25DAY9: "Депозитке 50% және сыйлыққа 50 FS!",
    NYDAY1: "Hell Hot 100 ойынында 50 FS",
    NYDAY10: "Santa's Great Gifts ойынында 50 FS",
    NYDAY11: "Спортқа фрибет!",
    NYDAY12: "Aviator-ға фрибеттер",
    NYDAY13: "Депозитке 75% және сыйлыққа 75 FS!",
    NYDAY14: "Sugar Rush Xmas ойынында 100 FS",
    NYDAY2: "Депозитке 50% және сыйлыққа 50 FS!",
    NYDAY3: "Спортқа фрибет!",
    NYDAY4: "JetX-ке фрибеттер",
    NYDAY5: "Депозитке 75% және сыйлыққа 75 FS!",
    NYDAY6: "Twin fruits of Santa ойынында 75 FS",
    NYDAY7: "Депозитке 100% және сыйлыққа 100 FS!",
    NYDAY8: "Sugar Rush Xmas ойынында 100 FS",
    NYDAY9: "Депозитке 50% және сыйлыққа 50 FS!"
  },
  promocodes2025: {
    NY25DAY1: "Santa's Gift ойынында 50 FS",
    NY25DAY10: "Спортқа​•​фрибет!",
    NY25DAY11: "Santa's​ ​Great​ Gifts​ ойынында​ 50​ FS",
    NY25DAY12: "Royal Xmass 2 ойынында 75 FS",
    NY25DAY13: "Депозитке 75% және сыйлыққа 75 FS!",
    NY25DAY14: "Santa's Xmas Rush ойынында 100 FS",
    NY25DAY2: "Спортқа​•​фрибет!",
    NY25DAY3: "Депозитке​ ​50%​ ​және​ сыйлыққа​ 50​ FS!",
    NY25DAY4: "Buffalo Power: Christmas ойынында 75 FS",
    NY25DAY5: "Депозитке 75% және сыйлыққа 75 FS!",
    NY25DAY6: "Royal Xmass ойынында 75 FS",
    NY25DAY7: "Депозитке 100% және сыйлыққа 100 FS!",
    NY25DAY8: "Sugar Rush Xmas ойынында 100 FS",
    NY25DAY9: "Депозитке 50% және сыйлыққа 50 FS!"
  },
  promotionNotFound: "Мұндай науқан жоқ",
  protectYouData: "Жеке деректеріңіз бен қаражатты қорғаңыз",
  protection: "Құпиялылық саясаты",
  protectionSettingsMessage: "Аккаунттың қауіпсіздігін икемдеу сіздің қаражатыңызды сақтау және оны қауіпсіз шығару үшін қажет",
  providers: "Провайдерлер",
  purchaseCryptocurrency: "Криптовалюта сатып алу",
  putSend: "Кодты алу",
  queue: "Кезекте",
  reSendCode: "Кодты қайта жіберу",
  read: "Оқылды",
  readyForWithdrawOnCashier: "Кассадан шешуге дайын",
  receiveWithdrawalConfirmation: "Қаражат шешу растауын электрондық пошта/Telegram арқылы алу",
  recomend: "Ұсынамыз",
  recovery: "Парольді қалпына келтіру",
  recoveryEmailDesc: "Аккаунтқа кіру үшін тіркелу кезінде көрсеткен электрондық поштаны енгізіңіз",
  recoveryPassword: "Парольді қалпына келтіру",
  recoveryPhoneDesc: "Аккаунтқа кіру үшін, тіркелу кезінде көрсеткен телефон нөмірін енгізіңіз",
  recoveryWord: "Қалпына келтіру",
  refill: "Толтыру",
  refresh: "Жаңарту",
  refreshPage: "Парақшаны жаңарту",
  refund: "Қайтару",
  refundPolicy: "Қайтару саясаты",
  refundWithdrawal: "Қаражат шешуді жою",
  refundWithdrawalModalDesc: "Қаражат шешуді жойғыңыз келетініне сенімдісіз бе? Аударым жойылған жағдайда, қаражат негізгі теңгерімге қайтарылады.",
  refundWithdrawalNoun: "Қаражат шешуді жою",
  reg: "Тіркелу",
  register: "Тіркелу",
  registrationBonus: "Тіркелу үшін бонус",
  rejected: "Кері қайтарылды",
  remainingPlay: "Ойнау үшін қалды",
  repeatPassword: "Парольді қайталаңыз",
  repeatTopUpDesc: "Төлем жасалмады ма? Қайталап көрейікші?",
  replenishment: "Толтыру",
  requirement: "Талап ",
  requisiteDesc: "Шотты толтыру үшін шотқа {sum} аударыңыз. Сәтті толтыру үшін сома көрсетілген сомаға толығымен сәйкес келуі қажет.",
  resend: "Қайта жіберу",
  resendCodeCanAfter: "{0} кейін кодты қайта жіберуге болады",
  reset: "Қалпына келтіру",
  resetFilters: "Фильтрді қалпына келтіру",
  resetIt: "оны қалпына келтіріңіз",
  responsibleGame: "Жауапты ойын",
  result: "Қорытынды",
  results: "Нәтижелер",
  resultsSearch: "Іздеу нәтижелері",
  "return": "Қайтару",
  rollback: "Кері қайтару",
  rules: "Ережелер және шарттар",
  rulesDescription: "Ережелер",
  rulesShort: "Ережелер",
  rulesTournament: "Турнирдің шарттары мен ережелері",
  russian: "Орыс",
  sales: "Сатылды",
  save: "Сақтау",
  schedule: "Кесте",
  scores: "ұпайлар",
  search: "Іздеу",
  searchProviders: "Провайдердің атауы",
  seats: "Орындар",
  secretAnswer: "Бақылау сұраққа жауап",
  secretQuestion: "Бақылау сұрақ",
  security: {
    five: "Егер сізде деректерді қорғауға қатысты сұрақтарыңыз болса, онлайн қолдау қызметіне хабарласыңыз немесе {support} электрондық поштасына хат жіберіңіз. Біз сізге көмектесуге қуаныштымыз.",
    one: "Бұл ақпаратты қорғау туралы мәлімдемені әлемдік стандарттар бойынша бизнес жүргізуге бейім екенімізді көрсету үшін жариялап отырмыз.",
    seven: "Ақпаратты қорғау",
    six: "Веб-сайттағы қызметтер мен ақпаратты «Euromirbet d.o.o.» компаниясы ұсынады, Podgorica, Cetinjski put bb, reg. no. 5-0685623/1. Payment Card Industry Security Standards Council ұсыныстарына сәйкес тұтынушылар туралы деректерді қорғау үшін шифрлау көліктік деңгейде - TLS 1.2 және қолданбалы деңгейде 256 бит кілтінің ұзындығымен AES алгоритмімен қолданылады.",
    three: "{titlePure} спамға қарсы саясатты ұстанады. Біздің ойыншыларға жіберілген барлық хаттар олардың ойын шоттарына байланысты, сонымен қатар олардың казинодағы жаңа мүмкіндіктері туралы ақпарат және тиісті жарнамалық материалдар болуы мүмкін. Жарнамалық хабарламалардың жиілігі әр түрлі болуы мүмкін және күніне 3 хатқа дейін жетеді. Ойыншылар жазылымнан бас тарту құқығын өзіне қалдырады - бұл жағдайда онлайн қолдау қызметіне хабарласу немесе кез-келген уақытта хаттың төменгі жағындағы тиісті сілтемені басу арқылы жазылымнан бас тарту қажет. Сіздің ұтыстарыңыз және сіз жасаған төлемдер туралы ақпарат құпия болып табылады және қауіпсіз ортада сақталады.",
    two: "Біз жақсы бизнес қарым-қатынас тек адалдық пен сенімге негізделген деп сенеміз. Сондықтан сіздің ақпаратыңыздың құпиялығы біз үшін өте маңызды. Сіз транзакциялардың қауіпсіздігін қамтамасыз ету үшін барлық шараларды қолданатынымызды біле отырып, ойыннан ләззат ала аласыз. Сіздің аты-жөніңіз, пошталық мекен-жайыңыз, электрондық поштаңыздың мекен-жайы, телефон нөміріңіз, туған күніңіз, жынысыңыз, IP-мекен-жайыңыз және басқа ақпарат жеке және құпия болып табылады, сондықтан оны үшінші тұлғаларға беру, сату немесе тарату мүмкін емес."
  },
  securityAnswer: "Құпия жауап",
  securityQuestion: "Құпия сұрақ",
  securitySetting: "Қауіпсіздік икемдеуі",
  selectAll: "Барлығын белгілеу",
  selectApproveMethod: "Қаражат шешудің растау әдісін таңдаңыз",
  selectCountryToReceive: "Аймақтағы ағымдағы ұсыныстар мен шарттарды алу үшін елді таңдаңыз",
  selectPaymentCurrencyAndClickTopUpAccount: "Есеп айырысу валютасын таңдап, «Шотты толтыру» батырмасын басыңыз",
  selectProviders: "Таңдалған провайдерлердің барлық ойындары",
  selectQuestion: "Алдымен сұрақты таңдаңыз",
  selectVariable: "Қолайлы нұсқаны таңдаңыз",
  sellBet: "Ставканы сату",
  send: "Жіберу",
  sendCode: "Кодты жіберу",
  sendCodeError: "Кодты енгізу мүмкін емес, қолдау қызметіне",
  sendCodeErrorSupport: "хабарласыңыз",
  sendCodeRepeat: "Кодты қайта жіберу",
  sendCodeSuccess: "Код телефонға жіберілді ",
  sendCodeSuccessEmail: "Код электрондық поштаға жіберілді",
  sendConfirmationEmail: "__ электрондық поштасына растау хаты жіберілді",
  sendConfirmationPhone: "Біз {phone} нөміріне SMS код жібердік.",
  sendDocuments: "Құжаттарды жіберу",
  sendSMS: "SMS кодын жіберу",
  sendedCodeToEmail: "Код поштаға жіберілді <br> {email}",
  sendedCodeToPhone: "Код телефонға жіберілді <br> {phone}",
  september: "қыркүйек",
  serverErrorTryAgain: "Сервер қатесі, қайталап көріңіз",
  serverErrorTryRefresh: "Сервер қатесі, жаңартып көріңіз",
  settlementCurrency: "Төлем валютасы",
  sgtv_bonus: {
    block_one_li_four: "10 фрибет алыңыз.",
    block_one_li_one: "Бонусты алу үшін теңгеріміңізде кемінде {sum} {currency} болуы қажет.",
    block_one_li_three: "Лоббиде бонусты белсендіріңіз.",
    block_one_li_two: "Бонусты белсендіру үшін SGTV провайдерінің кез келген ойынына өтіңіз.",
    block_one_title: "Өз бонусыңызды қалай алуға болады:",
    block_two_li_eight: "Бонусқа х20 вейджер салынады. Ойнату кезіндегі ең төменгі коэффициент 1.5-ке тең.",
    block_two_li_eleven: "Olymp ұсыныстың шарттарын жеке-дара және кез келген сәтте өзгерту немесе жою, сондай-ақ себептерін түсіндірмей кез келген ойыншыға бас тарту құқығын өзіне қалдырады.",
    block_two_li_five: "Жаңа ойыншыға Sport Games бөліміне кірген кезде {sum} {currency} 10 фрибет беріледі.",
    block_two_li_four: "Бонус бірден қосылады. Егер таңдалған бонус қосылмаса, ойын басталмас бұрын қолдау қызметіне хабарласу қажет. Егер ойынды бонуссыз бастасаңыз, ол есептелмейді.",
    block_two_li_nine: "Депозитсіз фрибеттерден және депозитсіз бонустардан алынған ұтыстың ең жоғары сомасы - {sum} {currency}.",
    block_two_li_one: "Пайдаланушы тек бір бонусқа құқылы.",
    block_two_li_seven: "Бонус белсендірілген сәттен бастап 3 күн ішінде қолжетімді.",
    block_two_li_six: "Фрибеттерді «Бокс», «Дартс», «Бридж», «Буллиттер», «Нард» ойындарында пайдалануға болады.",
    block_two_li_ten: "Фрибеттерді 1.3-тен 5-ке дейінгі коэффициентке ставкалар үшін пайдалануға болады.",
    block_two_li_three: "Бонусты алу үшін {sum} {currency} мөлшерінде толықтыру жасау қажет.",
    block_two_li_two: "Бонустар (фрибеттер) бірде-бір рет SportgamesTV-де ставкалар жасамаған ойыншыларға беріледі.",
    block_two_title: "Шарттар мен ережелер:",
    important_text: "Маңызды! Егер сіз ойынды бонусты белсендірмей бастасаңыз, фрибеттер кейін қосылмайды.",
    title: "SportGamesTV-да жаңа ойыншылар үшін фрибеттер! «Нард», «Бокс», «Дартс», «Бридж», «Буллиттер» ойындарына 10 фрибет алыңыз."
  },
  shallWePlay: "Ойнаймыз ба?",
  shortDescription: "Қысқаша сипаттамасы",
  show: "Көрсету",
  showAll: "Барлығын көрсету",
  showBets: "Ставкаларды көрсету",
  showCodeOnlyForOperator: "Растау кодын кассирден басқа ешкімге жарияламаңыз",
  showGame: "Ойынды көрсету",
  showGames: "Ойындарды көрсету",
  showMatchesStarting: "Матчтарды көрсету:",
  showMoreGames: "Көбірек ойындарды көрсету",
  showTerms: "Шарттарын көрсету",
  showTransactions: "Транзакцияларды көрсету",
  signUp: "Тіркелу",
  signUpAndVerifyVolet: "Тіркеліңіз және тексеруден өтіңіз, ол 15 минутты алады",
  signin: "Жүйеге кіру",
  silver: "Күміс",
  slots: "Слоттар",
  smallDescription: "Турнир туралы қысқаша сипаттама",
  smsCode: "SMS кодын алу",
  smsInfo: "Сіздің нөміріңізге SMS-код жіберіледі",
  smsSendingDesc: "Нөмірге жіберілген кодты енгізіңіз",
  smsVer: "SMS арқылы төлемдерді тексеру",
  smsVerDisabled: "Төлемдерді SMS арқылы тексеру өшірілген",
  smsVerEnabled: "Төлемдерді SMS арқылы растау қосылды",
  socialAuthError: "Әлеуметтік желі арқылы кіру қатесі",
  soonStarted: "Жақында басталады",
  sort: "Сұрыптау",
  spaceNotAvailableForField: "Бұл өрісте бос орындарға рұқсат етілмейді",
  specifyNumberYourPersonalCryptoWallet: "В поле укажите номер вашего личного крипто-кошелька на сайте Olimp.com.",
  spinsBeforeCrediting: "Толтыруға дейінгі айналдыру саны:",
  sportErrorText: "Біз қазір «Спорт» бөлімін жаңартудамыз, бірақ жақын арада барлығын қалпына келтіреміз.",
  sports: "Спорт",
  stakeHasBeenSuccessfully: "Сіздің ставкаңыз сәтті қабылданды!",
  startSecuritySetup: "Қауіпсіздік икемдеуден өтіңіз",
  stateOfAnAccount: "Шоттың күйі",
  status: "Статус\n",
  statusAcc: "Аккаунт мәртебесі:",
  statusOfTransaction: "Транзакция мәртебесі",
  statusSuccess: "Расталды",
  statuses: {
    calculationInProgress: "Есептеу орындалуда",
    inProcess: "Орындалуда",
    notPayed: "Төленбеді",
    payed: "Төленді"
  },
  sub_telegram: "Телеграмға жазыл",
  success: "Әрекет сәтті өтті",
  successEnterTournament: "Керемет, сіз турнирдесіз!",
  successPromoCode: "Промокод сәтті белсендірілді",
  sufficient: "жеткілікті",
  sum: "Сомасы",
  sumBet: "Ставка сомасы",
  sumMoreThanBalance: "Сома теңгерімдегі сомадан көбірек",
  sumWithdraw: "Төлем сомасы",
  support: "Қолдау қызметі",
  supportContact: "Қолдау қызметіне хабарласу",
  surname: "Тегі",
  suspended: "Тоқтатылды",
  system: "Жүйе",
  table: "Үстел үсті",
  tapOnHome: "«Үйге экранына» батырмасын басып, «Дайын» батырмасын басыңыз",
  tapOnShareIcon: "Экранның төменгі жағындағы мәзірдегі «Бөлісу» белгішесін түртіңіз. Диалогтық терезе ашылады",
  term: "Толтыру мерзімі",
  termEnrollment: "Толтыру мерзімі:",
  termFulfillment: "Шарттарды орындау мерзімі:",
  termsAndConditions: "Шарттар мен талаптармен",
  termsAndConditionsList: "Шарттар мен ережелер",
  timeFulfill: "Шарттарды орындау уақыты:",
  timeRemaining: {
    txt: "Кодты қайта алуға  {seconds} секунд қалды",
    txtPay: "Жаңа кодты {seconds} кейін алуға болады"
  },
  timeToActivateBonus: "Бонусты белсендіру үшін уақыт",
  timer: {
    oneLetter: {
      day: "д",
      hour: "ч",
      minute: "м",
      second: "с"
    },
    "short": {
      day: "күн.",
      hour: "сағ.",
      minute: "мин.",
      second: "сек."
    }
  },
  tip: "Шайпұл",
  titles: {
    cashback: "Cashback\n",
    dropsWins: "Drops and wins\n",
    err404: "Талап етілген бет жоқ",
    fraud: "Алаяқтықтан қорғау",
    gameGroups: {
      "GamesByGroup\/slot": "Слоттар онлайн – ойын автоматтарында тіркелусіз тегін, ақшаға ойнау"
    },
    home: "{titlePure}",
    profile: "Профиль\n",
    protection: "Ақпаратты қорғау",
    responsibleGame: "Жауапты ойын",
    rules: "Шарттар мен талаптар",
    tournaments: "Турнирлер",
    work: "Техникалық жұмыстар жүргізілуде"
  },
  to: "{date} дейін",
  toFindOutWalletAddressOfCoin: "Кез-келген монетаның әмиянының мекенжайын білу үшін негізгі экранда алғыңыз келетін монетаны нұқыңыз, содан кейін транзакциялар тарихы бар монета беті көрсетіледі",
  toPromoStart: "Акцияның басталуына дейін",
  toSupport: "қолдау қызметіне",
  topLines: "Желінің үздік матчтары",
  topUp: "Толтыру",
  topUpWith: "Толтыру",
  topupYourBalance: "Ақшаға ойнау үшін шотты толтырыңыз",
  total: "Барлығы",
  tournament: "Турнир",
  tournamentCryptoReminderText: "Жеңіске жету үшін жеке кабинетте Doge крипто әмиянын көрсетуді ұмытпаңыз ",
  tournamentDescription: "Турнирдің сипаттамасы",
  tournamentEnded: "Турнир аяқталды",
  tournamentGame: "Ойын турнирге қатысады",
  tournamentGames: "Турнир ойындары",
  tournamentMounth: {
    "01": "Қаңтар",
    "02": "Ақпан",
    "03": "Наурыз",
    "04": "Сәуір",
    "05": "Мамыр",
    "06": "Маусым",
    "07": "Шілде",
    "08": "Тамыз",
    "09": "Қыркүйек",
    "10": "Қазан",
    "11": "Қараша",
    "12": "Желтоқсан"
  },
  tournaments: "Турнирлер",
  transactionCopied: "Сіз транзакция id нөмірін көшірдіңіз",
  transactionSuccess: "Транзакция сәтті аяқталды",
  transactionsIsNotExist: "Сізде ешқандай транзакция болған жоқ",
  transactionsNotFound: "Таңдалған фильтрлер үшін транзакциялар табылмады. Фильтр параметрлерін өзгертіп көріңіз немесе {0}",
  transfer: "Аудару",
  transferAccount: "Шотқа аудару",
  transferAmount: "Аударым сомасын енгізіңіз",
  transferAmount2: "Аударым сомасын енгізіңіз",
  transferSuccessfully: "Ақша аударымы сәтті аяқталды!",
  transferTheMoneyAndWait: "Ақшаны кассирге беріңіз және толтыруды күтіңіз",
  transitionDate: "Транзакция күні",
  transitionStatus: "Транзакция күйі",
  transitionType: "Транзакция түрі",
  turnOff: "Өшіру",
  turnOn: "Қосу",
  turnOnState: "Қосылған",
  turnover: "Айналым",
  twoFactorAuth: "Екі факторлы аутентификация",
  typeOfTransaction: "Транзакция түрі",
  uncalculated: "Есептелмегендер",
  underCoinBalanceClickGetButton: "Монета балансының астында «Алу» батырмасын басыңыз.  Әрі қарай мекенжайды батырманы пайдаланып көшіру керек немесе сканерлеу үшін штрих кодты пайдалану керек",
  unexpectedErrorWriteToSupport: "Күтпеген қате пайда болды, бірақ оны жақын арада түзетеміз.",
  unexpected_error_try_again: "Күтпеген қате, қайталап көріңіз",
  unhandledErrorTryToRefreshPage: "Күтпеген қате, парақшаны жаңартып көріңіз",
  unselect: "Белгілеуді жою",
  untilStartLeft: "Басталуына дейін",
  update: "Жаңарту",
  upload: "Еңгізу",
  uzbek: "Өзбек",
  verification: "Верификация",
  verificationDeclined: "Верификация орындалмады. Қолдау қызметіне хабарласуыңызды өтінеміз.",
  verificationDeclinedInfo: "Құжаттар тексеруден өтпеді. Құжаттарды қайта тіркеңіз немесе қолдау қызметіне хабарласыңыз.",
  verificationInProgress: "Верификация орындалуда. Күтуіңізді өтінеміз.",
  verificationsSMSDesc: "Төлемді тексеру үшін тіркелу кезінде көрсеткен телефон нөмірін растаңыз",
  verifyYourAccount: "Аккаунтыңды раста",
  virtuals: "В-Спорт",
  wager: "Вейджер",
  wagerGame: {
    accessAfterRolePlay: "Ойын бонустқа ставка жасағаннан кейін қолжетімді болады",
    gamesWagering: "Ставка жасау мүмкіндігі бар ойындар",
    nowPlayed: "Қазір ойнады",
    remainForPlay: "Ойнау үшін қалды"
  },
  wallet: "Әмиян",
  walletCopied: "Әмиян көшірілді",
  walletId: "Әмиян мекенжайы",
  walletNotLinked: "Әмиян байланбаған",
  way: "Шешу әдісі",
  ways: "Шешу әдістері",
  wbCashboxActiveText: "Бонус шотына депозитке 100% алу үшін, шотыңызды {minSum} сомасынан толтырыңыз. Негізгі шот бонусқа ставка жасаған соң қолжетімді болады.",
  wbCashboxNotActiveText: "Бонус шотына депозитке 100% алу үшін, бонусты жеке кабинетте белсендіріңіз.",
  wbWaitOnProfile: "Сізді жеке кабинетіңіздің «Бонустар» бөлімінде сәлемдесу бонусы күтуде",
  welcomeBonus: "Welcome бонусыңды",
  welcomeBonusCasino: "Welcome бонусыңды казино",
  welcomeBonusDescription: "Төлемді бір сағат ішінде жасауға үлгеріңіз және толтыру үшін ұлғайтылған  <span class='text-accent'>125%</span> бонус және 250 фриспинге дейін алыңыз!",
  welcomeBonusSport: "Welcome бонусыңды спорт",
  welcomeBonusTitle: " Welcome бонусқа +25%",
  win: "Жеңіс",
  winnerPoints: "Жеңіс",
  winners: "Ұтқандар",
  withAnIncrease: "Көбейгенде",
  withDrawOrdered: "Қаражатты шешу рәсімделді",
  withDrawOrderedDesc: "Қаражат жақын арада сіздің көрсетілген шотыңызға аударылады.",
  withInstantCashback: "Жедел кэшбэкпен",
  withdraw: "Шығару",
  withdraw2: "Шығару",
  withdrawBK: "БК-ге шығару",
  withdrawFunds: "Қаражат шығару",
  withdrawMethod: "Шығару әдісі",
  withdrawMethods: "Шығару әдістері",
  withdrawNoun: "Шығару",
  withdrawPaymentInfo: "Visa/Mastercard әдісі арқылы қаражатты шешу тек логинге байланған карталарға ғана қолжетімді. Картаны байлау  үшін Visa/Mastercard әдісі арқылы логиніңізді толтыруыңыз қажет.",
  withdrawPerDayCountExceeded: "Сіз күн сайын 1 шешуге дейін орындай аласыз",
  withdrawTelegramBot: "Қаражатты шешу үшін Telegram ботын іске қосып, оған кіру қажет",
  withdrawWithApprove: "Кодты растау арқылы қаражатты шешу",
  withdrawWithCode: "Растау коды арқылы қаражатты шешу",
  withdrawal: "Қаражат шығаруға шектеулер",
  withdrawalCompletedSuccessfully: "Шоттан шығаруға тапсырыс қалыптастырылды",
  withdrawalOfFunds: "Растау коды арқылы қаражатты шешу",
  work: "Техникалық жұмыстар жүргізілуде",
  writeToSupport: "Қолдау қызметіне жазу",
  yes: "Иә",
  yesConfirm: "Иә, сенімдімін",
  yesOfCourseIWant: "Иә, әрине қалаймын",
  yesRefundWithdrawal: "Иә, қаражат шешуді жою",
  yesSure: "Иә, мен шотты толтырдым",
  you: "Сіз",
  youAreAuthorized: "Сіз жүйеге кірдіңіз",
  youAreParticipateInTheTournament: "Сіз турнирге қатысасыз!",
  youDontHaveTransactions: "Сізде транзакциялар болған жоқ",
  youHaveNewMessage: "Сізде жаңа хабарлама бар",
  youHaveNotNewMessages: "Сізде жаңа хабарламалар жоқ",
  youHaveSmsVerification: "Сіз төлемді растауды қостыңыз, аударым жасау үшін SMS арқылы тексеруден өтіңіз",
  youTakePart: "Сіз қатысасыз",
  yourBalance: "Сіздің теңгеріміңіз",
  yourCasinoBonus: "Сіздің казинодағы бонусыңыз",
  yourCurrentEmail: "Сіздің қазіргі электрондық поштаңыз",
  yourCurrentPhone: "Сіздің қазіргі нөміріңіз",
  yourEmail: "Сіздің электрондық поштаңыз",
  yourPersonalUniqueWalletIsDisplayedHere: "Мұнда сіз бұрын таңдаған монета үшін жеке бірегей әмияныңыз көрсетілген. Әмиянның мекенжайын көшіру үшін арнайы батырманы немесе QR кодын пайдалануға болады."
} 
